import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges, AfterViewInit, Output, EventEmitter, InjectionToken } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormGroupDirective } from '@angular/forms';
import { AppMainComponent } from 'src/app/app.main.component';
import { ContactService } from 'src/app/contacts/contactService';
import { ContactService as SharedContactSerice } from "./api/api";
import { Contact } from './model/contact';
import { Status } from 'src/app/models/statusEnums';
import { AutoComplete } from 'primeng/autocomplete';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { ObjectNames } from '../../../../shared/constants';
import { PermissionService } from '../../../../service/permission.service';
import { getFormattedContacts } from '../../../../contacts/contacts.helper';
import { DatePipe } from '@angular/common';
import { AppMainService } from 'src/app/app-main.service';
import { StoreService } from 'src/app/modules/shared/services/store.service';
import { Configuration } from 'src/app/accounts-v2/models/configuration/configuration.model';
import { ContactHttpService } from 'src/app/modules/shared/services/contact.http.service';
import { SharedDataService } from '../../stores/sharedDataStore/sharedData.service';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { TypeGroupIds } from '../../constants/category-groupid.constants';
import { ContactRelationService } from './api/contact-relation.service';
import { Subject } from 'rxjs';
import { ContactRelation } from './model/contact-relation.model';
import { PhoneNumberFormatModuleId } from '../../constants/modules.constant';
import { PhoneNumberFormatService } from '../../services/phone-number-format.service';
import { GelAllContactRequestModel } from '../../models/filter.model';
import { Fields } from '../../models/column-settings.model';
import { SharedContactV1Service } from '../shared-contacts-v1/shared-contact-v1-Service';
export const ASSOCIATION_TYPE_NAME_ACCOUNT = new InjectionToken<string>('associationTypeName');
@Component({
    selector: 'lion-shared-contacts',
    templateUrl: './shared-contacts.component.html',
    styleUrls: ['./shared-contacts.component.scss'],
})

export class LionSharedContactsComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() moduleName;
    @Input() selectedChannel;
    @Input() contactAssociationId: number;
    @Input() allAssociationNamesList = [];
    @Input() object;
    @Input() accountAssociationNames = [];
    @Input() contacts: Contact[] = [];
    @Input() isViewMode: boolean = false;
    @Input() addUpdateDone: boolean = false;
    @Input() isDisableAssociation = false;
    @Input() hideRigthArrow = false;
    @Input() noContactFindOrLoadingText: string = 'Loading....';
    @Input() accountAddressTypes: any[] = [];
    @Input() addressClasses: any[] = [];
    @Input() countries: any[] = [];
    @Input() hasChildAccounts: boolean = false;
    @Input() selectedChannelN;
    @Output() contactInfo = new EventEmitter();
    @Output() contactUpdated = new EventEmitter();
    @Output() contactDeleted = new EventEmitter();
    @Input() associationTypeName: string;
    contactsData = [];
    allContacts = []
    contactCols = []
    contactCols2 = []
    contactColsAll = []
    contactColsAllTemp = []
    allContactsData = [];
    contactByNameCols = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
        { field: 'fullName', header: 'Contact Name', show: true, value: '', checked: true, order: false },
    ];
    billingAddressTypeId = 38;
    shippingAddressTypeId = 39;
    otherAddressTypeId = 40;
    contactTemp = {
        "id": 0,
        "createdSource": this.app.userIP,
        "createdBy": this.app.user.userId,
        "createdDate": new Date(),
        "firstName": "",
        "middleName": "",
        "lastName": "",
        "genderId": 0,
        "title": "",
        "sourceId": 0,
        "dateOfBirth": new Date(),
        "description": "",
        "contactAddresses": [],
        "startDate": new Date(),
        "isPrimaryContact": false,
        "contactAssociationTypeId": 0,
        "associationId": 0,
        "associationName": "",
        "degreeId": 0,
        "fieldOfStudyId": 0,
        "contactTypeId": 0,
        "relationshipStatusId": 0,
        "maritalStatusId": 0,
        "annualIncomeId": 0,
        "jobFunction": "",
        "department": "",
        "seniority": "",
        "reportsToId": 0,
        "assistantId": 0,
        "assistantPhone": "",
        "organizationId": this.app.user.organizationId,
        "statusId": Status.Active,
        "contactEmails": [
            {
                "id": 0,
                "createdSource": this.app.userIP,
                "createdBy": this.app.user.userId,
                "createdDate": new Date(),
                "contactId": 0,
                "emailId": 0,
                "email": {
                    "id": 0,
                    "createdSource": this.app.userIP,
                    "createdBy": this.app.user.userId,
                    "createdDate": new Date(),
                    "emailAddress": "",
                    "description": "",
                    "emailTypeId": 0,
                    "statusId": Status.Active
                },
                "emailTypeDD": {
                    "name": "Work",
                    "groupId": TypeGroupIds.EmailTypeId,
                    "group": null,
                    "parentTypeId": 0,
                    "description": "",
                    "statusId": Status.Active,
                    "status": null,
                    "organizationId": null,
                    "colorCodeId": null,
                    "id": 30,
                    "createdSource": "10.1.1.1",
                    "updatedSource": null,
                    "createdBy": this.app.user.userId,
                    "updatedBy": null,
                    "createdDate": new Date("2020-12-23T12:06:21.43"),
                    "updatedDate": null
                }
            }
        ],
        "contactPhones": [
            {
                "id": 0,
                "createdSource": this.app.userIP,
                "createdBy": this.app.user.userId,
                "createdDate": new Date(),
                "contactId": 0,
                "phoneId": 0,
                "phone": {
                    "id": 0,
                    "createdSource": this.app.userIP,
                    "createdBy": this.app.user.userId,
                    "createdDate": new Date(),
                    "number": "",
                    "extension": "",
                    "description": "",
                    "phoneTypeId": 0,
                    "statusId": Status.Active,
                },
                "phoneTypeDD": {
                    "name": "Mobile",
                    "groupId": TypeGroupIds.PhoneTypeId,
                    "group": null,
                    "parentTypeId": 0,
                    "description": "",
                    "statusId": Status.Active,
                    "status": null,
                    "organizationId": null,
                    "colorCodeId": null,
                    "id": 10,
                    "createdSource": "10.1.1.1",
                    "updatedSource": null,
                    "createdBy": this.app.user.userId,
                    "updatedBy": null,
                    "createdDate": new Date("2020-12-09T11:36:23.103"),
                    "updatedDate": null
                }
            }
        ],
        "contactSocialProfiles": [
            {
                "id": 0,
                "createdSource": this.app.userIP,
                "createdBy": this.app.user.userId,
                "createdDate": new Date(),
                "contactId": 0,
                "socialProfileId": 0,
                "socialProfile": {
                    "id": 0,
                    "createdSource": this.app.userIP,
                    "createdBy": this.app.user.userId,
                    "createdDate": new Date(),
                    "name": "",
                    "description": "",
                    "socialProfileTypeId": 0,
                    "statusId": Status.Active,
                },
                "socialProfileTypeDD": {
                    "name": "Website",
                    "groupId": TypeGroupIds.SocialTypeAccountAPI,
                    "group": null,
                    "parentTypeId": 0,
                    "description": "",
                    "statusId": Status.Active,
                    "status": null,
                    "organizationId": null,
                    "colorCodeId": null,
                    "id": 34,
                    "createdSource": "10.1.1.1",
                    "updatedSource": null,
                    "createdBy": this.app.user.userId,
                    "updatedBy": null,
                    "createdDate": new Date("2020-12-23T12:59:39.467"),
                    "updatedDate": null
                }
            }
        ],
        "contactSpokenLanguages": [
            {
                "id": 0,
                "createdSource": this.app.userIP,
                "createdBy": this.app.user.userId,
                "createdDate": new Date(),
                "contactId": 0,
                "languageId": 0,
                "statusId": Status.Active
            }
        ],
        "contactProfileImages": [],
    };
    filteredContacts = [];
    contactStages = [];
    contactStagesAll = [];
    addressCountry = []
    addressState = []
    addressCity = []
    menuItems;
    @ViewChild('createContact') createContact: FormGroupDirective;
    // selectedContact;
    selectedId;
    selectedContactFromTable = 0;
    configMenuItems = [];
    configMenuItemsCM = [];
    isEmailOrPhoneThere = true;
    // contactModalHeader = '';
    // contactPopupOpenMode;
    // displayContactAddEdit = false;
    displayContactView = false;
    displayMap = false;
    displayAddEvent = false;
    displaySendEmail = false;
    displayAddLog = false;
    displayActivityTaskAdd = false;
    displayNotesAdd = false;
    disaplayAddAddressDialog = false;
    showAddMore = false;
    maxNo = false;
    totalAmt = 0;
    myCheckbox: boolean;
    birthDate: Date;
    tab: any;
    tab1: any
    tab2: any
    showDiv = {
        collists: true,
        ddvalues: false,
    };
    options: any;
    overlays: any[];
    sources = [];
    selectedSource;
    languages = [];
    selectedLanguage;
    selectedContactRole = [];
    genders = [];
    selectedGender;
    contactTypes = [];
    salutations = [];
    selectedContactType;
    contactAssociation = [];
    selectedContactAssociation;
    relations = [];
    selectedRelation;
    maritals = [];
    contactRoles = [];
    selectedMarital;
    incomes = [];
    selectedIncome;
    emailtype = [];
    selectedEmailType;
    phonetype = [];
    selectedPhoneType;
    socials = [];
    selectedSocial;
    shippingCountries = [];
    selectedCountry;
    selectedCountryShipping;
    states = [];
    shippingStates = [];
    selectedState;
    selectedStateShipping;
    cities = [];
    shippingCities = [];
    selectedCity;
    selectedCityShipping;
    degrees = []
    selectedDegree;
    studyFields = []
    selectedStudyField;
    reports = []
    selectedReportsTo;
    assistants = []
    selectedAssistant;
    selectedSalutation;
    attns = []
    selectedAttn;
    selectedView = 'list';
    addressTemp;
    associationName;
    associationNames = [];
    @ViewChild('associationNameDD') associationNameDD: AutoComplete
    emailtypes: any;
    phonetypes: any;
    socialtypes: any;
    storedContactDetails: any;
    newObject: any;
    labels_info: any;
    labels_address: any;
    labels_addition: any;

    // permissions
    readPermission = false;
    writePermission = false;
    editPermission = false;
    deletePermission = false;
    exportPermission = false;

    contactConfigs: Configuration[] = [];
    displayRelationship: boolean = false;

    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();

    // relationship = [
    //     {id:1,companyName:"Company 1", billingAddr:"",shippingAddr:"",access:true},
    //     {id:2,companyName:"Company 2", billingAddr:"",shippingAddr:"",access:false},
    // ]
    //#region new variable
    relationship: ContactRelation[] = [];
    selectedAccount: any;
    hasAccessAll: boolean;
    displayContactAddEdit = false;
    contactModalHeader = '';
    contactPopupOpenMode: 'view' | 'edit' | 'add' = 'add';
    selectedContact: any = null;
    pageSize: number = 15;
    selectedColumn:{ columnName: string; isCustom: boolean }[];
    savedListColsVM: Fields[] = [];
    isActive: boolean = true;
    searchValue = "";
    selectedRecent = { label: 'All Contacts', code: 'allcontacts' };
    pageNumber: number = 1;
    totalRecords: number = 0;

    constructor(
        private appMainService: AppMainService,
        private contactService: ContactService,
        private contactHttpService: ContactHttpService,
        public app: AppMainComponent,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private sharedContactService: SharedContactSerice,
        private configService: ConfigurationService,
        private permissionService: PermissionService,
        private storeService: StoreService,
        private sharedDataService: SharedDataService,
        private datePipe: DatePipe,
        private contactRelationService: ContactRelationService,
        private phoneNumberFormatService: PhoneNumberFormatService,
        private sharedContactV1Service: SharedContactV1Service
    ) { }

    ngOnInit(): void {
        const userPermissions = this.permissionService.getPemrissionData();

        if (userPermissions.length) {
            const contactUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CONTACT);
            if (contactUserPermission.permissions) {
                contactUserPermission.permissions = contactUserPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
            }

            this.readPermission = contactUserPermission && contactUserPermission.permissions[0] ? contactUserPermission.permissions[0].statusId == 1 : false;
            this.writePermission = contactUserPermission && contactUserPermission.permissions[1] ? contactUserPermission.permissions[1].statusId == 1 : false;
            this.editPermission = contactUserPermission && contactUserPermission.permissions[2] ? contactUserPermission.permissions[2].statusId == 1 : false;
            this.deletePermission = contactUserPermission && contactUserPermission.permissions[3] ? contactUserPermission.permissions[3].statusId == 1 : false;
            this.exportPermission = contactUserPermission && contactUserPermission.permissions[4] ? contactUserPermission.permissions[4].statusId == 1 : false;

            if (this.isViewMode) {
                this.writePermission = this.editPermission = this.deletePermission = false;
            }

            if (this.readPermission) {
                this.configMenuItems.push(
                    {
                        label: 'View',
                        icon: 'pi pi-list',
                        command: () => {
                            this.showEditContact({ id: this.selectedContact.id, contactAssociationTypeId: this.selectedContact?.contactAssociationTypeId, mode: 'view' });
                        }
                    }
                );
                this.configMenuItemsCM.push({
                    label: 'View',
                    icon: 'pi pi-list',
                    command: () => {
                        this.showEditContact({ id: this.selectedContact.id, contactAssociationTypeId: this.selectedContact?.contactAssociationTypeId, mode: 'view' });
                    }
                })
            }

            if (this.editPermission) {
                this.configMenuItems.push(
                    {
                        label: 'Edit',
                        icon: 'pi pi-pencil',
                        command: () => {
                            this.showEditContact({ id: this.selectedContact.id, contactAssociationTypeId: this.selectedContact?.contactAssociationTypeId, mode: 'edit' });
                        }
                    }
                )

                this.configMenuItemsCM.push({
                    label: 'Edit',
                    icon: 'pi pi-pencil',
                    command: () => {
                        this.showEditContact({ id: this.selectedContact.id, contactAssociationTypeId: this.selectedContact?.contactAssociationTypeId, mode: 'edit' });
                    }
                })
            }

            if (this.deletePermission) {
                this.configMenuItems.push(
                    {
                        label: 'Delete',
                        icon: 'pi pi-trash',
                        command: () => {
                            this.deleteContact(this.selectedContact);
                        }
                    }
                )

                this.configMenuItemsCM.push({
                    label: 'Delete',
                    icon: 'pi pi-trash',
                    command: () => {
                        this.deleteContact(this.selectedContact);
                    }
                })
            }

        }
        // this.getAllContacts();
        this.newObject = this.object;
        this.associationName = this.object['businessName'];

        this.contactColsAll = JSON.parse(JSON.stringify(this.contactCols) || null);

        // Get Values from Behavior Subject
        this.getContactDropdownValues();
        this.getConfigurationsFromStore();

        !this.salutations?.length && this.sharedDataService.dispatchGettingAllStores();

        // Call All Dropdown APIs
        this.loadContactTypes();
        this.loadGenders();
        this.loadLanguages();
        this.loadRelationshipStatuses();
        this.loadMaritalStatuses();
        this.loadAnnualIncomes();
        this.loadDegrees();
        this.loadFieldOfStudies();
        this.loadContactAssociations();

        /* Those four APIs have no use  */
        // this.contactService.getAllCountries().then(countries => {
        //     this.countries = countries;
        //     this.shippingCountries = countries;
        // });

        // this.contactService.getAllEmailTypes().then(types => {
        //     this.emailtype = types;
        // });

        // this.contactService.getAllPhoneTypes(this.app.phoneType).then(types => {
        //     this.phonetype = types;
        // });

        // this.contactService.getAllSocialProfiles(this.app.socialProfileType).then(profiles => {
        //     this.socials = profiles;
        // });

        this.getContactConfigurations();

        // this.configService.getAllConfiguration().subscribe(configs => {
        //   this.emailtypes = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES && s.typeId == 93)[0].configurationDetails[0].configJSONValue);
        //   this.phonetypes = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES && s.typeId == 94)[0].configurationDetails[0].configJSONValue);
        //   this.socialtypes = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES && s.typeId == 95)[0].configurationDetails[0].configJSONValue);
        //   let allContactTemplates = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACT_TEMPLATE && s.typeId == 99)[0].configurationDetails[0].configJSONValue);
        //   this.labels_info = allContactTemplates[0].labels_info;
        //   this.labels_address = allContactTemplates[0].labels_address;
        //   this.labels_addition = allContactTemplates[0].labels_addition;
        // });

        // this.contactService.getAllReportsTo().then(users => {
        //   this.reports = users;
        // });

        // this.contactService.getAllAssistant().then(assis => {
        //   this.reports = assis;
        // });

        this.contactCols2 = [
            { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
            { field: 'fullName', header: 'Contact Name', show: true, value: '', checked: true, order: false },
            { field: 'associationName', header: 'Association Name', show: true, value: '', checked: true, order: false },
            { field: 'firstName', header: 'First Name', show: false, value: '', checked: false, order: false },
            { field: 'lastName', header: 'Last Name', show: false, value: '', checked: false, order: false },
            { field: 'title', header: 'Title', show: false, value: '', checked: false, order: false },
            { field: 'source', header: 'Contact Source', show: true, value: '', checked: true, order: false },
            { field: 'state', header: 'State', show: false, value: '', checked: false, order: false },
            { field: 'city', header: 'City', show: false, value: '', checked: false, order: false },
            { field: 'email', header: 'Work Email', show: true, value: '', checked: true, order: false },
            { field: 'phone', header: 'Phone Number', show: true, value: '', checked: true, order: false },
            { field: 'social', header: 'Social Profile', show: false, value: '', checked: false, order: false },
            { field: 'birth', header: 'Date of Birth', show: false, value: '', checked: false, order: false },
            { field: 'gender', header: 'Gender', show: false, value: '', checked: false, order: false },
            { field: 'language', header: 'Language', show: false, value: '', checked: false, order: false },
            { field: 'contactType', header: 'Contact Type', show: true, value: '', checked: true, order: false },
            { field: 'relation', header: 'Relationship Status', show: false, value: '', checked: false, order: false },
            { field: 'marital', header: 'Marital Status', show: false, value: '', checked: false, order: false },
            { field: 'income', header: 'Annual Income', show: false, value: '', checked: false, order: false },
            { field: 'degree', header: 'Degree', show: false, value: '', checked: false, order: false },
            { field: 'studyField', header: 'Field of Study', show: false, value: '', checked: false, order: false },
            { field: 'seniority', header: 'Seniority', show: false, value: '', checked: false, order: false },
            { field: 'assistantPhone', header: 'Assistant Phone', show: false, value: '', checked: false, order: false },
            { field: 'report', header: 'Reports To', show: false, value: '', checked: false, order: false },
            { field: 'assistant', header: 'Assistant', show: false, value: '', checked: false, order: false },
        ];

        this.contactCols = [
            { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
            { field: 'fullName', header: 'Contact Name', show: true, value: '', checked: true, order: false }
        ];
    }

    getContactDropdownValues(): void {
        this.storeService.getContactTypes()
            .subscribe(contactTypes => {
                this.contactTypes = contactTypes;
            });

        this.sharedDataService.loadSalutations()
            .pipe(map(salutations => {
                this.salutations = salutations;
            }), catchError(() => []))
            .subscribe();

        this.storeService.getGenders()
            .subscribe(genders => {
                this.genders = genders;
            });

        this.storeService.getLanguages()
            .subscribe(languages => {
                this.languages = languages;
            });

        this.sharedDataService.loadJobFunctions()
            .pipe(map(contactRoles => {
                this.contactRoles = contactRoles;
            }), catchError(() => []))
            .subscribe();

        this.storeService.getRelationshipStatuses()
            .subscribe(relations => {
                this.relations = relations;
            });

        this.storeService.getMaritalStatuses()
            .subscribe(maritals => {
                this.maritals = maritals;
            });

        this.sharedDataService.loadSources()
            .pipe(map(sources => {
                this.sources = sources;
            }), catchError(() => []))
            .subscribe();

        this.storeService.getAnnualIncomes()
            .subscribe(incomes => {
                this.incomes = incomes;
            });

        this.storeService.getDegrees()
            .subscribe(degrees => {
                this.degrees = degrees;
            });

        this.storeService.getFieldOfStudies()
            .subscribe(studyFields => {
                this.studyFields = studyFields;
            });

        this.storeService.getContactAssociationTypes()
            .subscribe(contactAssociationTypes => {
                this.contactAssociation = contactAssociationTypes;
            });

        this.sharedDataService.loadAddressTypes()
            .pipe(map(addressTypes => {
                this.accountAddressTypes = addressTypes?.filter(el => el.isActive) || [];
            }), catchError(() => []))
            .subscribe();

        this.sharedDataService.loadAddressClasses()
            .pipe(map(addressClasses => {
                this.addressClasses = addressClasses?.filter(el => el.isActive) || [];
            }), catchError(() => []))
            .subscribe();

        this.sharedDataService.loadCountries()
            .pipe(map(countries => {
                this.countries = countries || [];
            }), catchError(() => []))
            .subscribe();
    }

    getConfigurationsFromStore(): void {
        this.storeService.getContactConfigurations()
            .subscribe(configs => {
                this.contactConfigs = configs;
                configs.length && this.setContactConfigurationsData(configs);
            });
    }

    loadContactTypes(): void {
        !this.contactTypes.length &&
            this.contactHttpService.getContactTypes().subscribe(contactTypes => {
                this.contactTypes = contactTypes;
                this.storeService.setContactTypes(this.contactTypes);
            });
    }

    loadGenders(): void {
        !this.genders.length &&
            this.contactService.getAllGender().then(genders => {
                this.genders = genders;
                this.storeService.setGenders(this.genders);
            });
    }

    loadLanguages(): void {
        !this.languages.length &&
            this.contactService.getAllLanguage().then(languages => {
                this.languages = languages;
                this.storeService.setLanguages(this.languages);
            });
    }

    loadRelationshipStatuses(): void {
        !this.relations.length &&
            this.contactService.getAllRelationshipStatus().then(status => {
                this.relations = status;
                this.storeService.setRelationshipStatuses(this.relations);
            });
    }

    loadMaritalStatuses(): void {
        !this.maritals.length &&
            this.contactService.getAllMaritalStatus().then(status => {
                this.maritals = status;
                this.storeService.setMaritalStatuses(this.maritals);
            });
    }

    loadAnnualIncomes(): void {
        !this.incomes.length &&
            this.contactService.getAllAnnualIncome().then(incomes => {
                this.incomes = incomes;
                this.storeService.setAnnualIncomes(this.incomes);
            });
    }

    loadDegrees(): void {
        !this.degrees.length &&
            this.contactService.getAllDegree().then(degrees => {
                this.degrees = degrees;
                this.storeService.setDegrees(this.degrees);
            });
    }

    loadFieldOfStudies(): void {
        !this.studyFields.length &&
            this.contactService.getAllStudyField().then(fields => {
                this.studyFields = fields;
                this.storeService.setFieldOfStudies(this.studyFields);
            });
    }

    loadContactAssociations(): void {
        !this.contactAssociation.length &&
            this.contactHttpService.getContactAssociationTypes().subscribe(contactAssociation => {
                this.contactAssociation = contactAssociation;
                this.storeService.setContactAssociationTypes(this.contactAssociation);
                this.updateContactAssociation();
            });
    }

    getContactConfigurations() {
        if (!this.contactConfigs.length) {
            this.appMainService.isShowSpinner('loadContactConfig');
            this.contactService.getContactConfigurations().subscribe(
                configs => {
                    this.contactConfigs = configs;
                    this.storeService.setContactConfigurations(configs);
                    this.appMainService.isHideSpinner('loadContactConfig');
                }, () => {
                    this.appMainService.isHideSpinner('loadContactConfig');
                }
            );
        }
    }

    setContactConfigurationsData(configs: Configuration[]): void {
        this.emailtypes = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES &&
            s.typeId == 93)[0].configurationDetails[0].configJSONValue);
        this.phonetypes = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES &&
            s.typeId == 94)[0].configurationDetails[0].configJSONValue);
        this.socialtypes = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES &&
            s.typeId == 95)[0].configurationDetails[0].configJSONValue);
        let allContactTemplates = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACT_TEMPLATE &&
            s.typeId == 99)[0].configurationDetails[0].configJSONValue);
        this.labels_info = allContactTemplates[0].labels_info;
        this.labels_address = allContactTemplates[0].labels_address;
        this.labels_addition = allContactTemplates[0].labels_addition;
    }

    updateContactAssociation() {
        let index = this.contactAssociation.findIndex(el => el.name === this.contactAssociationId);

        if (index > -1) {
            this.selectedContactAssociation = this.contactAssociation[index];
            this.contactTemp.associationId = this.object.id;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.object && changes.object.currentValue) {
            this.newObject = changes.object.currentValue;
        }

        if (changes.contacts && changes.contacts.currentValue) {
            this.reports = [];
            if (this.selectedView == 'split' && changes.contacts.currentValue.length == 0) { this.selectedView = 'list'; }
            changes.contacts.currentValue.filter(contactObj => {
                this.reports.push({
                    firstName: `${contactObj?.firstName}`,
                    name: `${contactObj?.firstName} ${contactObj?.lastName}`,
                    id: contactObj?.id
                })
            });
            this.updateContactAssociation();
            setTimeout(() => {
                this.getAllContacts();
            })
        }

        if (changes.allAssociationNamesList && changes.allAssociationNamesList.currentValue) {
            this.associationNames = changes.allAssociationNamesList.currentValue;
            //this.associationName = this.allAssociationNamesList.find(el=>el.businessName ==)?.businessName
        }

        if (changes?.isViewMode?.currentValue) {
            this.isViewMode = changes.isViewMode.currentValue;

            if (this.isViewMode) {
                this.writePermission = this.editPermission = this.deletePermission = false;
            }
        }

        if (changes.addUpdateDone && changes.addUpdateDone.currentValue) {
            this.addUpdateDone = changes.addUpdateDone.currentValue;
        }
    }

    setAssociationNames() {
        setTimeout(() => {
            if (this.allAssociationNamesList && this.allAssociationNamesList.length > 0) {
                this.addItem(this.allAssociationNamesList.filter(el => el.businessName === this.object.businessName)[0], this.associationNameDD);
            }
        }, 300)
    }
    ngAfterViewInit() {
        this.setAssociationNames();
    }

    addItem(option: any, autoCompleteComponent: AutoComplete) {
        if (autoCompleteComponent) autoCompleteComponent.el.nativeElement.value = '';
        if (autoCompleteComponent) autoCompleteComponent.value = autoCompleteComponent.value || [];
        if (autoCompleteComponent && !autoCompleteComponent.isSelected(option)) {
            autoCompleteComponent.value = [...autoCompleteComponent.value, option];
            autoCompleteComponent.onModelChange(autoCompleteComponent.value);
        }

        autoCompleteComponent && autoCompleteComponent.onSelect.emit(option);
        autoCompleteComponent && autoCompleteComponent.el.nativeElement.focus();
    }

    onRowSelect($event: any) {
        //debugger;
        this.selectedContact;
        //debugger;
        this.filteredContacts = [...this.contactsData.filter(p => p.id == $event.data.id)];

        this.app.objectId = this.selectedContact.id;
        this.app.objectType = "Contact";
        this.selectedId = this.selectedContact.id;
        this.selectedContactFromTable = this.selectedContact.id;
        //debugger;
        this.contactColsAllTemp = this.contactColsAll;
        this.contactCols = this.contactByNameCols;
        this.selectedView = 'split';

    }

    backListView() {
        this.selectedView = 'list';
        this.selectedContact = null;
        this.contactColsAll = this.contactColsAllTemp;
        this.contactCols = this.contactColsAll;
    }

    getAllContacts() {
        this.contacts = this.contacts.filter(el => el != null);
        this.allContactsData = [];
        this.contactsData = [];

        if (this.contacts) {
            for (let l of this.contacts) {
                const eachContact: any = getFormattedContacts(l, this.datePipe, this.contactAssociation);
                eachContact.isPrimaryContact = l.isPrimaryContact;
                eachContact.childAccountAccess = l?.childAccountAccess||0;
                this.allContactsData.push(eachContact);
            }
            this.contactsData = this.allContactsData;
        }
        if (this.selectedContact) {
            this.onRowSelect({ data: { id: this.selectedContact.id } });
        }
    }

    // newContact(event) {
    //     this.selectedLanguage = [];
    //     this.contactTemp = {
    //         "id": 0,
    //         "createdSource": this.app.userIP,
    //         "createdBy": this.app.user.userId,
    //         "createdDate": new Date(),
    //         "firstName": "",
    //         "middleName": "",
    //         "lastName": "",
    //         "genderId": 0,
    //         "title": "",
    //         "sourceId": 0,
    //         "dateOfBirth": new Date(),
    //         "description": "",
    //         "contactAddresses": [],
    //         "startDate": new Date(),
    //         "isPrimaryContact": false,
    //         "contactAssociationTypeId": this.contactAssociationId,
    //         "associationId": this.object?.id,
    //         "associationName": this.object?.businessName,
    //         "degreeId": 0,
    //         "fieldOfStudyId": 0,
    //         "contactTypeId": 0,
    //         "relationshipStatusId": 0,
    //         "maritalStatusId": 0,
    //         "annualIncomeId": 0,
    //         "jobFunction": "",
    //         "department": "",
    //         "seniority": "",
    //         "reportsToId": 0,
    //         "assistantId": 0,
    //         "assistantPhone": "",
    //         "organizationId": this.app.user.organizationId,
    //         "statusId": Status.Active,
    //         "contactEmails": [],
    //         "contactPhones": [],
    //         "contactSocialProfiles": [],
    //         "contactSpokenLanguages": [
    //             {
    //                 "id": 0,
    //                 "createdSource": this.app.userIP,
    //                 "createdBy": this.app.user.userId,
    //                 "createdDate": new Date(),
    //                 "contactId": 0,
    //                 "languageId": 0,
    //                 "statusId": Status.Active
    //             }
    //         ],
    //         contactProfileImages: []
    //     };
    //     this.emailtypes.forEach(element => {
    //         if (element.checked == true) {
    //             let email = {
    //                 "id": 0,
    //                 "createdSource": this.app.userIP,
    //                 "createdBy": this.app.user.userId,
    //                 "createdDate": new Date(),
    //                 "contactId": 0,
    //                 "emailId": 0,
    //                 "email": {
    //                     "id": 0,
    //                     "createdSource": this.app.userIP,
    //                     "createdBy": this.app.user.userId,
    //                     "createdDate": new Date(),
    //                     "emailAddress": "",
    //                     "description": "",
    //                     "emailTypeId": 0,
    //                     "statusId": Status.Active
    //                 },
    //                 "emailTypeDD": {
    //                     "name": "Work",
    //                     "groupId": TypeGroupIds.EmailTypeId,
    //                     "group": null,
    //                     "parentTypeId": 0,
    //                     "description": "",
    //                     "statusId": Status.Active,
    //                     "status": null,
    //                     "organizationId": null,
    //                     "colorCodeId": null,
    //                     "id": 30,
    //                     "createdSource": "10.1.1.1",
    //                     "updatedSource": null,
    //                     "createdBy": this.app.user.userId,
    //                     "updatedBy": null,
    //                     "createdDate": new Date("2020-12-23T12:06:21.43"),
    //                     "updatedDate": null
    //                 }
    //             };
    //             email.email.emailTypeId = element.id;
    //             email.emailTypeDD = element;
    //             this.contactTemp.contactEmails.push(email);
    //         }
    //     });
    //     this.phonetypes.forEach(element => {
    //         if (element.checked == true) {
    //             let phone = {
    //                 "id": 0,
    //                 "createdSource": this.app.userIP,
    //                 "createdBy": this.app.user.userId,
    //                 "createdDate": new Date(),
    //                 "contactId": 0,
    //                 "phoneId": 0,
    //                 "phone": {
    //                     "id": 0,
    //                     "createdSource": this.app.userIP,
    //                     "createdBy": this.app.user.userId,
    //                     "createdDate": new Date(),
    //                     "number": "",
    //                     "extension": "",
    //                     "description": "",
    //                     "phoneTypeId": 0,
    //                     "statusId": Status.Active,
    //                 },
    //                 "phoneTypeDD": {
    //                     "name": "Mobile",
    //                     "groupId": TypeGroupIds.PhoneTypeId,
    //                     "group": null,
    //                     "parentTypeId": 0,
    //                     "description": "",
    //                     "statusId": Status.Active,
    //                     "status": null,
    //                     "organizationId": null,
    //                     "colorCodeId": null,
    //                     "id": 10,
    //                     "createdSource": "10.1.1.1",
    //                     "updatedSource": null,
    //                     "createdBy": this.app.user.userId,
    //                     "updatedBy": null,
    //                     "createdDate": new Date("2020-12-09T11:36:23.103"),
    //                     "updatedDate": null
    //                 }
    //             };
    //             phone.phone.phoneTypeId = element.id;
    //             phone.phoneTypeDD = element;
    //             this.contactTemp.contactPhones.push(phone);
    //         }
    //     });
    //     this.socialtypes.forEach(element => {
    //         if (element.checked == true) {
    //             let social = {
    //                 "id": 0,
    //                 "createdSource": this.app.userIP,
    //                 "createdBy": this.app.user.userId,
    //                 "createdDate": new Date(),
    //                 "contactId": 0,
    //                 "socialProfileId": 0,
    //                 "socialProfile": {
    //                     "id": 0,
    //                     "createdSource": this.app.userIP,
    //                     "createdBy": this.app.user.userId,
    //                     "createdDate": new Date(),
    //                     "name": "",
    //                     "description": "",
    //                     "socialProfileTypeId": 0,
    //                     "statusId": Status.Active,
    //                 },
    //                 "socialProfileTypeDD": {
    //                     "name": "Website",
    //                     "groupId": TypeGroupIds.SocialTypeAccountAPI,
    //                     "group": null,
    //                     "parentTypeId": 0,
    //                     "description": "",
    //                     "statusId": Status.Active,
    //                     "status": null,
    //                     "organizationId": null,
    //                     "colorCodeId": null,
    //                     "id": 34,
    //                     "createdSource": "10.1.1.1",
    //                     "updatedSource": null,
    //                     "createdBy": this.app.user.userId,
    //                     "updatedBy": null,
    //                     "createdDate": new Date("2020-12-23T12:59:39.467"),
    //                     "updatedDate": null
    //                 }
    //             };
    //             social.socialProfile.socialProfileTypeId = element.id;
    //             social.socialProfileTypeDD = element;
    //             this.contactTemp.contactSocialProfiles.push(social);
    //         }
    //     });
    //     this.addressState = [[], []];
    //     this.addressCountry = [[], []];
    //     this.addressCity = [[], []];
    //     this.selectedLanguage = [];
    //     this.contactTemp.startDate = null;
    //     this.contactTemp.dateOfBirth = null;
    //     this.contactModalHeader = 'Add New Contact';
    //     this.displayContactAddEdit = true;
    //     this.contactPopupOpenMode = 'save';
    // }
// #region new Contact
    newContact(event: Event): void {
        this.associationName = this.object['businessName'];
        this.associationTypeName = this.moduleName  ;
        this.contactModalHeader = 'Add Contact';
        this.contactPopupOpenMode = 'add';
        this.selectedContact = null;
        this.displayContactAddEdit = true;
      }
      soModuleContact(event: Event): void {
        this.associationName = this.object?.businessName ;
        this.associationTypeName = this.contactAssociation?.find(el => el.id === this.contactAssociationId)?.name?.toLowerCase();
        this.contactModalHeader = 'Add Contact';
        this.contactPopupOpenMode = 'add';
        this.selectedContact = null;
        this.displayContactAddEdit = true;
    }
      onDisplayChange(event: boolean): void {
        this.displayContactAddEdit = event;
        if (!event) {
          this.selectedContact = null;
          this.contactModalHeader = '';
          // this.contactPopupOpenMode = '';
        }
        this.contactInfo.emit();
      }

      loadContacts(
        currentPageNumber: number = 1,
        currentPageSize: number = this.pageSize,
        isShowLoader: boolean = true,
        fromUpdateSettings: boolean = false,
      ) {
        this.contactUpdated.emit();
        this.pageSize = currentPageSize;
        if (isShowLoader) {
          this.appMainService.isShowSpinner('getAllContactLoader');
        }
       
        //#region Select Column
        const selectableColumns: any[] = [];
        this.selectedColumn = [];
        
        if (this.savedListColsVM.length > 0) {
          this.savedListColsVM.forEach((obj) => {
            if (obj.enabled) {
              selectableColumns.push(
                {
                  columnName: obj.columnName,
                  isCustom: obj.isCustom
                }
              )
            }
          });
          this.selectedColumn = [...selectableColumns];
        }
    
        //#endregion Select Column
        const requestModel: GelAllContactRequestModel = {
          associationTypeName: this.associationTypeName,
          isActive: this.isActive,
          globalSearchValue: this.searchValue.trim() || '',
          selectableColumns: this.selectedColumn,
          filter: this.selectedRecent.code || 'allcontacts',
          pageSize: currentPageSize,
          pageNumber: currentPageNumber,
          sortByColumn: null,
          isSortByDescending: true,
          filterableColumns: [],
          globalChannelId: 1,
        };
        this.sharedContactV1Service.getContactList(requestModel)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (response) => {
              this.contacts = JSON.parse(JSON.stringify(response.list));
              this.totalRecords = response.totalNumberOfRows;
              if (isShowLoader) {
                this.appMainService.isHideSpinner('getAllContactLoader');
              }
            },
            (error) => {
              console.error('Error loading contacts', error);
              if (isShowLoader) {
                this.appMainService.isHideSpinner('getAllContactLoader');
              }
            }
          );
      }

    search(query) {
        let filtered: any[] = [];
        for (let i of this.allAssociationNamesList) {
            let associationName = i;
            if (associationName.businessName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(associationName);
            }
        }
        this.associationNames = filtered;
    }

    onKeyUp(event: KeyboardEvent) {
        if (event.key == "Enter" || event.key == "Tab") {
            let tokenInput = event.srcElement as any;
            if (tokenInput.value) {
                let obj = this.allAssociationNamesList.filter(r => r.name.toLowerCase().startsWith(tokenInput.value.toLowerCase()))[0];
                this.contactTemp.associationName = this.app.copyObjectWithoutRefrence(obj);
                tokenInput.value = "";
            }
        }
    }

    onKeyUp1(event: KeyboardEvent) {
        if (event.key == "Enter" || event.key == "Tab") {
            let tokenInput = event.srcElement as any;
            if (tokenInput.value) {
                let obj = this.allAssociationNamesList.filter(r => r.name.toLowerCase().startsWith(tokenInput.value.toLowerCase()))[0];
                this.contactTemp.associationName = this.app.copyObjectWithoutRefrence(obj);
                tokenInput.value = "";
            }
        }
    }

    saveContact() {
        let contactData = JSON.parse(JSON.stringify(this.contactTemp) || null);
        if (contactData.dateOfBirth) {
            contactData.dateOfBirth = new Date(contactData.dateOfBirth);
        }
        if (contactData.startDate) {
            contactData.startDate = new Date(contactData.startDate);
        }
        const associationName = this.associationName && this.associationName.businessName ? this.associationName.businessName : this.associationName && this.associationName[0]?.businessName ? this.associationName[0].businessName : '';
        const associationNameId = this.associationName && this.associationName.id ? this.associationName.id : this.associationName && this.associationName.length ? this.associationName[0].id : 0;
        contactData.associationName = associationName;
        contactData.associationId = associationNameId

        let emails = contactData.contactEmails;
        emails = emails.filter((data) => {
            return data.emailTypeDD?.id !== 0 && data.email?.emailAddress !== ''
        });
        if (emails.length > 1) {
            emails.forEach(elem => {
                elem.email.emailTypeId = elem.emailTypeDD.id;
                delete elem.emailTypeDD;
            });
        } else if (emails.length > 0 && emails[0].email.emailAddress !== "") {
            emails[0].email.emailTypeId = emails[0].emailTypeDD.id;
            delete emails[0].emailTypeDD;
        } else {
            emails = null;
        }
        contactData.contactEmails = emails;

        let contactPhones = contactData.contactPhones;
        contactPhones = contactPhones.filter((data) => {
            return data.phoneTypeDD?.id !== 0 && data.phone?.number?.trim() && data.phone?.number !== ''
        });
        if (contactPhones.length > 1) {
            contactPhones.forEach(elem => {
                elem.phone.phoneTypeId = elem.phoneTypeDD.id;
                delete elem.phoneTypeDD;
            });
        } else if (contactPhones.length > 0 && contactPhones[0].phone.number !== "") {
            contactPhones[0].phone.phoneTypeId = contactPhones[0].phoneTypeDD.id;
            delete contactPhones[0].phoneTypeDD;
        } else {
            contactPhones = null;
        }
        contactData.contactPhones = contactPhones;

        if (contactPhones?.length > 0) {
            contactPhones.forEach(elem => {
              const phoneNumber = this.phoneNumberFormatService.removeMaskingFromNumber(elem.phone?.number);
              elem.phone.number = phoneNumber ? (elem.phone.code||'') + phoneNumber : '';
            });
            contactData.contactPhones = contactPhones;
          }

        let contactSocialProfiles = contactData.contactSocialProfiles;
        contactSocialProfiles = contactSocialProfiles.filter((data) => {
            return data.socialProfileTypeDD?.id !== 0 && data.socialProfile?.name !== ''
        });
        if (contactSocialProfiles.length > 1) {
            contactSocialProfiles.forEach(elem => {
                elem.socialProfile.socialProfileTypeId = elem.socialProfileTypeDD.id;
                delete elem.socialProfileTypeDD;
            });
        } else if (contactSocialProfiles.length > 0 && contactSocialProfiles[0].socialProfile.name !== "") {
            contactSocialProfiles[0].socialProfile.socialProfileTypeId = contactSocialProfiles[0].socialProfileTypeDD.id;
            delete contactSocialProfiles[0].socialProfileTypeDD;
        } else {
            contactSocialProfiles = null;
        }
        contactData.contactSocialProfiles = contactSocialProfiles;

        // let addresses = contactData.contactAddresses;
        // let addressValidationErrorExist = false;
        // for(let i = 0; i < addresses.length; i++){
        //   const elem = addresses[i];
        //   const currentAddCountry: any = this.addressCountry.length && this.addressCountry[i] && this.addressCountry[i].id ? this.addressCountry[i] : null;
        //   const currentAddState: any = this.addressState.length && this.addressState[i] &&  this.addressState[i].id ? this.addressState[i] : null;
        //   const currentAddCity: any = this.addressCity.length && this.addressCity[i] && this.addressCity[i].id ? this.addressCity[i] : null;

        //   if (elem.address.streetAddress1 !== "" || currentAddCountry || currentAddState || currentAddCity) {
        //     elem.contactId = 0;
        //     elem.addressId = 0;
        //     if (elem.address.streetAddress1 !== "" && currentAddCountry && currentAddCountry.id && currentAddState && currentAddState.id && currentAddCity && currentAddCity.id) {
        //       elem.address.countryId = this.addressCountry[i] ? this.addressCountry[i]['id'] : null;
        //       elem.address.stateId = this.addressState[i] ? this.addressState[i]['id'] : null;
        //       elem.address.cityId = this.addressCity[i] ? this.addressCity[i]['id'] : null;
        //       elem.address.latitude = 0;
        //       elem.address.longitude = 0;
        //       elem.statusId = Status.Active;
        //       if (elem.address.addressName === "Mailing Address") {
        //         elem.address.addressTypeId = this.billingAddressTypeId;
        //       } else if (elem.address.addressName === "Shipping Address") {
        //         elem.address.addressTypeId = this.shippingAddressTypeId;
        //       } else {
        //         elem.address.addressTypeId = this.otherAddressTypeId;
        //       }
        //       delete elem.index;
        //       delete elem.address.addressName;
        //       delete elem.address.city;
        //       delete elem.address.state;
        //       delete elem.address.country;
        //     } else {
        //       if(!elem.statusId || elem.statusId == Status.Active){
        //         this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please select country, state and city..." })
        //         addressValidationErrorExist = true;
        //         if(addressValidationErrorExist){
        //           break;
        //         }else{
        //           addressValidationErrorExist = false;
        //         }
        //       }
        //     }
        //   }
        // }
        // contactData.contactAddresses = addresses.filter(el => el.statusId !== undefined);
        if (this.selectedLanguage && this.selectedLanguage.length > 0) {
            for (const [index, eachLanguage] of this.selectedLanguage.entries()) {
                const temp = {
                    createdBy: this.app.user.userId,
                    createdSource: this.app.userIP,
                    languageId: eachLanguage.id,
                    statusId: Status.Active,
                }
                contactData.contactSpokenLanguages[index] = temp;
                if (!contactData.contactSpokenLanguages[index].language) {
                    contactData.contactSpokenLanguages[index].language = {
                        id: eachLanguage.id,
                        name: eachLanguage.name,
                        createdBy: this.app.user.userId,
                        createdSource: this.app.userIP,
                        statusId: Status.Active
                    }
                } else {
                    contactData.contactSpokenLanguages[index].language.id = eachLanguage.id;
                    contactData.contactSpokenLanguages[index].language.name = eachLanguage.name;
                    contactData.contactSpokenLanguages[index].language.createdBy = this.app.user.userId;
                    contactData.contactSpokenLanguages[index].language.createdSource = this.app.userIP;
                    contactData.contactSpokenLanguages[index].language.statusId = Status.Active;
                }

            }
            /* contactData.contactSpokenLanguages[0].createdBy = this.app.user.userId;
            contactData.contactSpokenLanguages[0].createdSource = this.app.userIP;
            contactData.contactSpokenLanguages[0].languageId = this.selectedLanguage.id;
            contactData.contactSpokenLanguages[0].statusId = Status.Active;
            if (!contactData.contactSpokenLanguages[0].language) {
              contactData.contactSpokenLanguages[0].language = {
                id: this.selectedLanguage.id,
                name: this.selectedLanguage.name,
                createdBy: this.app.user.userId,
                createdSource: this.app.userIP,
                statusId: Status.Active
              }
            } else {
              contactData.contactSpokenLanguages[0].language.id = this.selectedLanguage.id;
              contactData.contactSpokenLanguages[0].language.name = this.selectedLanguage.name;
              contactData.contactSpokenLanguages[0].language.createdBy = this.app.user.userId;
              contactData.contactSpokenLanguages[0].language.createdSource = this.app.userIP;
              contactData.contactSpokenLanguages[0].language.statusId = Status.Active;
            } */

        } else {
            contactData.contactSpokenLanguages = null;
        }

        this.setJobFunctionDataSet(contactData);
        contactData.organizationId = this.app.user.organizationId;
        contactData.statusId = Status.Active;

        contactData.genderId = this.selectedGender ? this.selectedGender.id : null;
        contactData.contactTypeId = this.selectedContactType ? this.selectedContactType.id : null;
        contactData.contactAssociationTypeId = this.selectedContactAssociation ? this.selectedContactAssociation.id : null;
        contactData.relationshipStatusId = this.selectedRelation ? this.selectedRelation.id : null;
        contactData.maritalStatusId = this.selectedMarital ? this.selectedMarital.id : null;
        contactData.sourceId = this.selectedSource ? this.selectedSource.id : null;
        contactData.annualIncomeId = this.selectedIncome ? this.selectedIncome.id : null;
        contactData.degreeId = this.selectedDegree ? this.selectedDegree.id : null;
        contactData.fieldOfStudyId = this.selectedStudyField ? this.selectedStudyField.id : null;
        contactData.reportsToId = this.selectedReportsTo ? this.selectedReportsTo.id : null;
        contactData.assistantId = this.selectedAssistant ? this.selectedAssistant.id : null;
        contactData.salutationId = this.selectedSalutation?.id||null;
        this.contactInfo.emit(JSON.parse(JSON.stringify(contactData)) || null);
        this.cancelAddContact({
            formtype: 'save',
            createContact: this.createContact
        });
        this.displayContactAddEdit = false;
    }

    cancelAddContact(event?) {
        this.contactTemp = {
            "id": 0,
            "createdSource": this.app.userIP,
            "createdBy": this.app.user.userId,
            "createdDate": new Date(),
            "firstName": "",
            "middleName": "",
            "lastName": "",
            "genderId": 0,
            "title": "",
            "sourceId": 0,
            "dateOfBirth": new Date(),
            "description": "",
            "contactAddresses": [
                // {
                //   "id": 0,
                //   "createdSource": this.app.user.userIP,
                //   "createdBy": this.app.user.userId,
                //   "createdDate": new Date(),
                //   "contactId": 0,
                //   "addressId": 0,
                //   "index": 0,
                //   "isSameAsMaillingAddress": false,
                //   "address": {
                //     "id": 0,
                //     "addressName": "Mailing Address",
                //     "name": "",
                //     "createdSource": this.app.user.userIP,
                //     "createdBy": this.app.user.userId,
                //     "createdDate": new Date(),
                //     "streetAddress1": "",
                //     "streetAddress2": "",
                //     "description": "",
                //     "latitude": 0,
                //     "longitude": 0,
                //     "cityId": 0,
                //     "stateId": 0,
                //     "countryId": 0,
                //     "zipCode": "",
                //     "addressTypeId": this.billingAddressTypeId,
                //     "statusId": Status.Active
                //   }
                // },
                // {
                //   "id": 0,
                //   "createdSource": this.app.user.userIP,
                //   "createdBy": this.app.user.userId,
                //   "createdDate": new Date(),
                //   "contactId": 0,
                //   "addressId": 0,
                //   "index": 1,
                //   "isSameAsMaillingAddress": false,
                //   "address": {
                //     "id": 0,
                //     "addressName": "Shipping Address",
                //     "name": "",
                //     "createdSource": this.app.user.userIP,
                //     "createdBy": this.app.user.userId,
                //     "createdDate": new Date(),
                //     "streetAddress1": "",
                //     "streetAddress2": "",
                //     "description": "",
                //     "latitude": 0,
                //     "longitude": 0,
                //     "cityId": 0,
                //     "stateId": 0,
                //     "countryId": 0,
                //     "zipCode": "",
                //     "addressTypeId": this.shippingAddressTypeId,
                //     "statusId": Status.Active
                //   }
                // }
            ],
            "startDate": new Date(),
            "isPrimaryContact": false,
            "contactAssociationTypeId": 0,
            "associationId": 0,
            "associationName": "",
            "degreeId": 0,
            "fieldOfStudyId": 0,
            "contactTypeId": 0,
            "relationshipStatusId": 0,
            "maritalStatusId": 0,
            "annualIncomeId": 0,
            "jobFunction": "",
            "department": "",
            "seniority": "",
            "reportsToId": 0,
            "assistantId": 0,
            "assistantPhone": "",
            "organizationId": this.app.user.organizationId,
            "statusId": Status.Active,
            "contactEmails": [
                {
                    "id": 0,
                    "createdSource": this.app.userIP,
                    "createdBy": this.app.user.userId,
                    "createdDate": new Date(),
                    "contactId": 0,
                    "emailId": 0,
                    "email": {
                        "id": 0,
                        "createdSource": this.app.userIP,
                        "createdBy": this.app.user.userId,
                        "createdDate": new Date(),
                        "emailAddress": "",
                        "description": "",
                        "emailTypeId": 0,
                        "statusId": Status.Active
                    },
                    "emailTypeDD": {
                        "name": "Work",
                        "groupId": TypeGroupIds.EmailTypeId,
                        "group": null,
                        "parentTypeId": 0,
                        "description": "",
                        "statusId": Status.Active,
                        "status": null,
                        "organizationId": null,
                        "colorCodeId": null,
                        "id": 30,
                        "createdSource": "10.1.1.1",
                        "updatedSource": null,
                        "createdBy": this.app.user.userId,
                        "updatedBy": null,
                        "createdDate": new Date("2020-12-23T12:06:21.43"),
                        "updatedDate": null
                    }
                }
            ],
            "contactPhones": [
                {
                    "id": 0,
                    "createdSource": this.app.userIP,
                    "createdBy": this.app.user.userId,
                    "createdDate": new Date(),
                    "contactId": 0,
                    "phoneId": 0,
                    "phone": {
                        "id": 0,
                        "createdSource": this.app.userIP,
                        "createdBy": this.app.user.userId,
                        "createdDate": new Date(),
                        "number": "",
                        "extension": "",
                        "description": "",
                        "phoneTypeId": 0,
                        "statusId": Status.Active,
                    },
                    "phoneTypeDD": {
                        "name": "Mobile",
                        "groupId": TypeGroupIds.PhoneTypeId,
                        "group": null,
                        "parentTypeId": 0,
                        "description": "",
                        "statusId": Status.Active,
                        "status": null,
                        "organizationId": null,
                        "colorCodeId": null,
                        "id": 10,
                        "createdSource": "10.1.1.1",
                        "updatedSource": null,
                        "createdBy": this.app.user.userId,
                        "updatedBy": null,
                        "createdDate": new Date("2020-12-09T11:36:23.103"),
                        "updatedDate": null
                    }
                }
            ],
            "contactSocialProfiles": [
                {
                    "id": 0,
                    "createdSource": this.app.userIP,
                    "createdBy": this.app.user.userId,
                    "createdDate": new Date(),
                    "contactId": 0,
                    "socialProfileId": 0,
                    "socialProfile": {
                        "id": 0,
                        "createdSource": this.app.userIP,
                        "createdBy": this.app.user.userId,
                        "createdDate": new Date(),
                        "name": "",
                        "description": "",
                        "socialProfileTypeId": 0,
                        "statusId": Status.Active,
                    },
                    "socialProfileTypeDD": {
                        "name": "Website",
                        "groupId": TypeGroupIds.SocialTypeAccountAPI,
                        "group": null,
                        "parentTypeId": 0,
                        "description": "",
                        "statusId": Status.Active,
                        "status": null,
                        "organizationId": null,
                        "colorCodeId": null,
                        "id": 34,
                        "createdSource": "10.1.1.1",
                        "updatedSource": null,
                        "createdBy": this.app.user.userId,
                        "updatedBy": null,
                        "createdDate": new Date("2020-12-23T12:59:39.467"),
                        "updatedDate": null
                    }
                }
            ],
            "contactSpokenLanguages": [
                {
                    "id": 0,
                    "createdSource": this.app.userIP,
                    "createdBy": this.app.user.userId,
                    "createdDate": new Date(),
                    "contactId": 0,
                    "languageId": 0,
                    "statusId": Status.Active
                }
            ],
            contactProfileImages: []
        };
        //if(event && event.createContact){this.createContact=event.createContact;}
        // this.createContact && this.createContact.form.reset();
        this.storedContactDetails = [];
        // if (event && event.formtype == 'save') {
        this.displayContactAddEdit = false;
        // } else {
        //   this.displayContactEdit = false;
        // }
    }

    deleteContact(contatcDetails: any) {
        if(contatcDetails?.parentChildRelationType=='Parent'){
            this.deleteContactRelationship(contatcDetails);
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Contact?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteContact');
                this.contactService.deleteContact(contatcDetails.id, contatcDetails.contactAssociationTypeId).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    const getIndex = this.contactsData.findIndex(el => el.id == contatcDetails.id);
                    this.contactsData.splice(getIndex, 1);
                    const getCIndex = this.contacts.findIndex(el => el.id == contatcDetails.id);
                    this.contacts.splice(getCIndex, 1);
                    this.storeService.setContactList(this.contacts);
                    this.selectedContact = null;
                    this.selectedView = 'list';
                    this.contactDeleted.emit(contatcDetails)
                    this.appMainService.isHideSpinner('deleteContact');
                }).catch((err) => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
                    this.appMainService.isHideSpinner('deleteContact');
                });
            },
            reject: () => {
            }
        });
    }

    deleteContactRelationship(contatcDetails: any) {
        this.confirmationService.confirm({
            message: 'This will remove the contact relationship not the actual contact!',
            header: 'Do you want to remove this contact relationship?',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteContactRelationship');
                this.contactService.deleteContactRelationship(this.object.id,contatcDetails.id).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact removed from the list...' });
                    const getIndex = this.contactsData.findIndex(el => el.id == contatcDetails.id);
                    this.contactsData.splice(getIndex, 1);
                    const getCIndex = this.contacts.findIndex(el => el.id == contatcDetails.id);
                    this.contacts.splice(getCIndex, 1);
                    this.storeService.setContactList(this.contacts);
                    this.selectedContact = null;
                    this.selectedView = 'list';
                    this.contactDeleted.emit(contatcDetails)
                    this.appMainService.isHideSpinner('deleteContactRelationship');
                }).catch((err) => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
                    this.appMainService.isHideSpinner('deleteContactRelationship');
                });
            },
            reject: () => {
            }
        });
    }

    getLanguageList(contactSpokenLanguages) {
        let list = [];
        contactSpokenLanguages.forEach(element => {
            list.push(this.languages.find(elem => elem.id === element.languageId));
        });
        return list;
    }

    makeContactPrimary(contactDetails: any): void {

        if(contactDetails?.statusId!=1 || contactDetails?.isPrimaryContact)return;

        if(this.moduleName=='Account'){
            this.makeAccountContactPrimary(contactDetails);
            return;
        }

        this.sharedContactService.lionO36020APIContactIdGet(contactDetails?.id,contactDetails?.contactAssociationTypeId).subscribe((contact: any) => {
            contact.isPrimaryContact = true;
            contact.territories = contact.territories?.map(el => {
                return {
                    ...el,
                    organizationId: this.app.user.organizationId,
                    statusId: 1
                }
            }) || null;
            this.appMainService.isShowSpinner('updateContact');

            delete contact.annualIncome;
            delete contact.contactAssociationType;
            contact.contactEmails = contact.contactEmails.length ? contact.contactEmails : null;
            contact.contactPhones = contact.contactPhones.length ? contact.contactPhones : null;
            if(contact?.contactPhones){
                contact?.contactPhones?.map(phone=>{
                    phone.phone.number = phone?.phone?.number ?  (phone?.phone?.code||'') + phone.phone.number :  '';
                })
            }
            contact.contactSocialProfiles = contact.contactSocialProfiles.length ? contact.contactSocialProfiles : null;
            contact.contactSpokenLanguages = contact.contactSpokenLanguages.length ? contact.contactSpokenLanguages : null;
            delete contact.contactType;
            delete contact.degree;
            delete contact.fieldOfStudy;
            delete contact.gender;
            delete contact.jobFunction;
            delete contact.maritalStatus;
            delete contact.relationshipStatus;
            delete contact.source;

            this.contactService.updateContact(contact).then((response) => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact updated successfully...' });
                this.storedContactDetails = [];
                this.selectedLanguage = [];
                this.displayContactAddEdit = false;
                this.contactUpdated.emit(JSON.parse(JSON.stringify(contact) || null));
                this.app.getAllObjects();
                this.addUpdateDone = true;
                this.appMainService.isHideSpinner('updateContact');
            }).catch(() => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
                this.appMainService.isHideSpinner('updateContact');
            });
        });
    }

    makeAccountContactPrimary(contactDetails: any){
        this.appMainService.isShowSpinner('updatePrimaryContact');
        this.contactRelationService.makeAccountPrimaryContact(this.object?.id,contactDetails?.id).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
            next: (response)=>{
                this.appMainService.isHideSpinner('updatePrimaryContact');
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Primary contact updated successfully...' });
                this.contactUpdated.emit(JSON.parse(JSON.stringify(contactDetails) || null));
                this.app.getAllObjects();
                this.addUpdateDone = true;
            },
            error: (error)=>{
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while making primary contact...' });
                this.appMainService.isHideSpinner('updatePrimaryContact');
            }
        })
    }

    showEditContact({ id, contactAssociationTypeId, mode }) {
        this.selectedContact = { id, contactAssociationTypeId, mode }
        this.associationTypeName = this.moduleName  ;
        this.associationName = this.object['businessName'];
        this.contactPopupOpenMode = mode;
        this.contactModalHeader = mode == 'view' ? 'View Contact' : 'Edit Contact';
        this.displayContactAddEdit = true;
        let thisContact;
        this.selectedLanguage = [];
        this.sharedContactService.lionO36020APIContactIdGet(id,contactAssociationTypeId).subscribe((contact: Contact) => {
            thisContact = JSON.parse(JSON.stringify(contact) || null);
            this.storedContactDetails = JSON.parse(JSON.stringify(thisContact) || null);
            const selectedGender = thisContact.genderId && thisContact.genderId > 0 ? this.genders.find(elem => elem.id === thisContact.genderId) : null;
            this.selectedGender = JSON.parse(JSON.stringify(selectedGender) || null);
            this.selectedLanguage = thisContact.contactSpokenLanguages && thisContact.contactSpokenLanguages.length > 0 ? this.getLanguageList(thisContact.contactSpokenLanguages) : [];
            this.selectedContactRole = thisContact.contactRoles.length ? this.contactRoles.filter(Role => thisContact.contactRoles.find(obj => obj.roleId == Role.id)) : [];

            const selectedRelation = thisContact.relationshipStatusId && thisContact.relationshipStatusId > 0 ? this.relations.find(elem => elem.id === thisContact.relationshipStatusId) : null;
            this.selectedRelation = JSON.parse(JSON.stringify(selectedRelation) || null);

            const selectedMarital = thisContact.maritalStatusId && thisContact.maritalStatusId > 0 ? this.maritals.find(elem => elem.id === thisContact.maritalStatusId) : null;
            this.selectedMarital = JSON.parse(JSON.stringify(selectedMarital) || null);

            const selectedSource = thisContact.sourceId && thisContact.sourceId > 0 ? this.sources.find(elem => elem.id === thisContact.sourceId) : null;
            this.selectedSource = JSON.parse(JSON.stringify(selectedSource) || null);

            const selectedIncome = thisContact.annualIncomeId && thisContact.annualIncomeId > 0 ? this.incomes.find(elem => elem.id === thisContact.annualIncomeId) : null;
            this.selectedIncome = JSON.parse(JSON.stringify(selectedIncome) || null);

            const selectedDegree = thisContact.degreeId && thisContact.degreeId > 0 ? this.degrees.find(elem => elem.id === thisContact.degreeId) : null;
            this.selectedDegree = JSON.parse(JSON.stringify(selectedDegree) || null);

            const selectedStudyField = thisContact.fieldOfStudyId && thisContact.fieldOfStudyId > 0 ? this.studyFields.find(elem => elem.id === thisContact.fieldOfStudyId) : null;
            this.selectedStudyField = JSON.parse(JSON.stringify(selectedStudyField) || null);

            this.selectedReportsTo = thisContact.reportsToId && thisContact.reportsToId > 0 ? this.reports.filter(elem => elem.id === thisContact.reportsToId)[0] : this.reports[0];
            this.selectedAssistant = thisContact.assistantId && thisContact.assistantId > 0 ? this.reports.filter(elem => elem.id === thisContact.assistantId)[0] : this.reports[0];

            const selectedContactType = thisContact.contactTypeId && thisContact.contactTypeId > 0 ? this.contactTypes.find(elem => elem.id === thisContact.contactTypeId) : null;
            this.selectedContactType = JSON.parse(JSON.stringify(selectedContactType) || null);

            this.selectedContactAssociation = thisContact.contactAssociationTypeId && thisContact.contactAssociationTypeId > 0 ? this.contactAssociation.filter(elem => elem.id === thisContact.contactAssociationTypeId)[0] : this.contactAssociation.filter(el => el.name === "Org Association")[0];
            const contactEmails = [];
            this.emailtypes.forEach(element => {
                if (element.checked == true) {
                    let email;
                    const checkEmail = thisContact.contactEmails && thisContact.contactEmails.length > 0 ? thisContact.contactEmails.find(el => el.email.emailTypeId == element.id) : null;
                    if (checkEmail) {
                        email = checkEmail
                    } else {
                        email = {
                            "id": 0,
                            "createdSource": this.app.userIP,
                            "createdBy": this.app.user.userId,
                            "createdDate": new Date(),
                            "contactId": 0,
                            "emailId": 0,
                            "email": {
                                "id": 0,
                                "createdSource": this.app.userIP,
                                "createdBy": this.app.user.userId,
                                "createdDate": new Date(),
                                "emailAddress": "",
                                "description": "",
                                "emailTypeId": 0,
                                "statusId": Status.Active
                            },
                            "emailTypeDD": {
                                "name": "Work",
                                "groupId": TypeGroupIds.EmailTypeId,
                                "group": null,
                                "parentTypeId": 0,
                                "description": "",
                                "statusId": Status.Active,
                                "status": null,
                                "organizationId": null,
                                "colorCodeId": null,
                                "id": 30,
                                "createdSource": "10.1.1.1",
                                "updatedSource": null,
                                "createdBy": this.app.user.userId,
                                "updatedBy": null,
                                "createdDate": new Date("2020-12-23T12:06:21.43"),
                                "updatedDate": null
                            }
                        };
                    }
                    email.email.emailTypeId = element.id;
                    email.emailTypeDD = element;
                    contactEmails.push(email);
                }
            });
            thisContact.contactEmails = [...contactEmails];
            const contactPhones = [];
            this.phonetypes.forEach(element => {
                if (element.checked == true) {
                    let phone;
                    const checkEmail = thisContact.contactPhones && thisContact.contactPhones.length > 0 ? thisContact.contactPhones.find(el => el.phone.phoneTypeId == element.id) : null;
                    if (checkEmail) {
                        phone = checkEmail;
                        phone.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(phone.phone?.number);
                    } else {
                        phone = {
                            "id": 0,
                            "createdSource": this.app.userIP,
                            "createdBy": this.app.user.userId,
                            "createdDate": new Date(),
                            "contactId": 0,
                            "phoneId": 0,
                            "phone": {
                                "id": 0,
                                "createdSource": this.app.userIP,
                                "createdBy": this.app.user.userId,
                                "createdDate": new Date(),
                                "number": "",
                                "extension": "",
                                "description": "",
                                "phoneTypeId": 0,
                                "statusId": Status.Active,
                            },
                            "phoneTypeDD": {
                                "name": "Mobile",
                                "groupId": TypeGroupIds.PhoneTypeId,
                                "group": null,
                                "parentTypeId": 0,
                                "description": "",
                                "statusId": Status.Active,
                                "status": null,
                                "organizationId": null,
                                "colorCodeId": null,
                                "id": 10,
                                "createdSource": "10.1.1.1",
                                "updatedSource": null,
                                "createdBy": this.app.user.userId,
                                "updatedBy": null,
                                "createdDate": new Date("2020-12-09T11:36:23.103"),
                                "updatedDate": null
                            }
                        };
                    }
                    phone.phone.phoneTypeId = element.id;
                    phone.phoneTypeDD = element;
                    contactPhones.push(phone);
                }
            });
            thisContact.contactPhones = [...contactPhones];
            const contactSocialProfiles = [];
            this.socialtypes.forEach(element => {
                if (element.checked == true) {
                    let social;
                    const checkEmail = thisContact.contactSocialProfiles && thisContact.contactSocialProfiles.length > 0 ? thisContact.contactSocialProfiles.find(el => el.socialProfile && el.socialProfile.socialProfileTypeId == element.id) : null;
                    if (checkEmail) {
                        social = checkEmail
                    } else {
                        social = {
                            "id": 0,
                            "createdSource": this.app.userIP,
                            "createdBy": this.app.user.userId,
                            "createdDate": new Date(),
                            "contactId": 0,
                            "socialProfileId": 0,
                            "socialProfile": {
                                "id": 0,
                                "createdSource": this.app.userIP,
                                "createdBy": this.app.user.userId,
                                "createdDate": new Date(),
                                "name": "",
                                "description": "",
                                "socialProfileTypeId": 0,
                                "statusId": Status.Active,
                            },
                            "socialProfileTypeDD": {
                                "name": "Website",
                                "groupId": TypeGroupIds.SocialTypeAccountAPI,
                                "group": null,
                                "parentTypeId": 0,
                                "description": "",
                                "statusId": Status.Active,
                                "status": null,
                                "organizationId": null,
                                "colorCodeId": null,
                                "id": 34,
                                "createdSource": "10.1.1.1",
                                "updatedSource": null,
                                "createdBy": this.app.user.userId,
                                "updatedBy": null,
                                "createdDate": new Date("2020-12-23T12:59:39.467"),
                                "updatedDate": null
                            }
                        };
                    }
                    social.socialProfile.socialProfileTypeId = element.id;
                    social.socialProfileTypeDD = element;
                    contactSocialProfiles.push(social);
                }
            });
            thisContact.contactSocialProfiles = [...contactSocialProfiles];
            if (thisContact.contactEmails === null && thisContact.contactPhones === null) {
                this.isEmailOrPhoneThere = false;
            } else {
                this.isEmailOrPhoneThere = true;
            }

            this.contactTemp = JSON.parse(JSON.stringify(thisContact) || null);
            this.displayContactAddEdit = true;
            this.contactPopupOpenMode = mode;
            this.contactModalHeader = mode == 'view' ? 'View Contact' : 'Edit Contact';
        })
    }

    setJobFunctionDataSet(contactData) {
        const contactRoles = [];
        if (this.selectedContactRole && this.selectedContactRole.length) {
            this.selectedContactRole.map(role => {
                const temp = {
                    "contactId": contactData ? contactData.id : 0,
                    "roleId": role.id,
                    "id": 0,
                    "createdSource": this.app.user.userIP,
                    "updatedSource": null,
                    "createdBy": this.app.user.userId,
                    "updatedBy": null,
                    "createdDate": new Date(),
                    "updatedDate": null,
                    "statusId": Status.Active
                }
                contactRoles.push(temp);
            })
        }
        contactData.contactRoles = contactRoles.length ? contactRoles : null;
    }

    updateEditContact() {
        let contactData = JSON.parse(JSON.stringify(this.contactTemp) || null);
        contactData.genderId = this.selectedGender ? this.selectedGender.id : null;
        delete contactData.gender;
        contactData.relationshipStatusId = this.selectedRelation ? this.selectedRelation.id : null;
        delete contactData.relationshipStatus;
        contactData.maritalStatusId = this.selectedMarital ? this.selectedMarital.id : null;
        delete contactData.maritalStatus;
        this.setJobFunctionDataSet(contactData);
        delete contactData.jobFunction;
        contactData.sourceId = this.selectedSource ? this.selectedSource.id : null;
        delete contactData.source;
        contactData.annualIncomeId = this.selectedIncome ? this.selectedIncome.id : null;
        delete contactData.annualIncome;
        contactData.degreeId = this.selectedDegree ? this.selectedDegree.id : null;
        delete contactData.degree;
        contactData.fieldOfStudyId = this.selectedStudyField ? this.selectedStudyField.id : null;
        delete contactData.fieldOfStudy;
        contactData.reportsToId = this.selectedReportsTo ? this.selectedReportsTo.id : null;
        contactData.assistantId = this.selectedAssistant ? this.selectedAssistant.id : null;
        contactData.contactTypeId = this.selectedContactType ? this.selectedContactType.id : null;
        delete contactData.contactType;
        contactData.contactAssociationTypeId = this.selectedContactAssociation ? this.selectedContactAssociation.id : null;
        delete contactData.contactAssociationType;
        contactData.updatedBy = this.app.user.userId;
        contactData.updatedDate = new Date();
        contactData.updatedSource = this.app.userIP;
        contactData.associationName = this.associationName?.businessName;

        if(this.selectedSalutation){
            this.selectedSalutation.organizationId = this.app.user.organizationId;
        }

        contactData.salutation = this.selectedSalutation;
        contactData.salutationId = this.selectedSalutation?.id||null;

        if (this.storedContactDetails && this.storedContactDetails.contactEmails && this.storedContactDetails.contactEmails.length > 0) {
            for (const stored of this.storedContactDetails.contactEmails) {
                const getActualEmail = contactData.contactEmails.find(el => el['email'].emailTypeId == stored['email'].emailTypeId);
                const getActualEmailIndex = contactData.contactEmails.findIndex(el => el['email'].emailTypeId == stored['email'].emailTypeId);
                if (getActualEmail && getActualEmail['email'].emailAddress == '') {
                    getActualEmail['email'].emailAddress = stored['email'].emailAddress;
                    getActualEmail['email'].statusId = 3;
                }
                contactData.contactEmails[getActualEmailIndex] = getActualEmail;
            }
        }
        let emails = contactData.contactEmails;
        emails = emails.filter((data) => {
            return data.emailTypeDD?.id !== 0 && data.email?.emailAddress !== ''
        });
        if (emails && emails.length > 1) {
            for (let i = 0; i < emails.length; i++) {
                if (emails[i].contactId !== 0) {
                    emails[i].updatedBy = this.app.user.userId;
                    emails[i].updatedDate = new Date();
                    emails[i].updatedSource = this.app.userIP;
                    emails[i].email.updatedBy = this.app.user.userId;
                    emails[i].email.updatedDate = new Date();
                    emails[i].email.updatedSource = this.app.userIP;
                }
                if (emails[i].createdBy === 0) {
                    emails[i].createdBy = this.app.user.userId;
                }
                if (emails[i].createdDate) {
                    emails[i].createdDate = new Date();
                }
                if (emails[i].createdSource === "") {
                    emails[i].createdSource = this.app.userIP;
                }
                if (emails[i].email.createdBy === 0) {
                    emails[i].email.createdBy = this.app.user.userId;
                }
                if (emails[i].email.createdDate) {
                    emails[i].email.createdDate = new Date();
                }
                if (emails[i].email.createdSource === "") {
                    emails[i].email.createdSource = this.app.userIP;
                }
                emails[i].email.emailTypeId = emails[i].emailTypeDD["id"];
                emails[i].email.emailTypeId = emails[i].emailTypeDD.id;
                if (emails[i].email.emailType) {
                    emails[i].email.emailType.name = emails[i].emailTypeDD.name;
                } else {
                    emails[i].email.emailType = {
                        name: emails[i].emailTypeDD.name
                    }
                }
                emails[i].email.emailAddress = emails[i].email.emailAddress;
                delete emails[i].emailTypeDD;
            }
        } else if (emails && emails.length > 0 && emails[0].email.emailAddress !== "") {
            emails[0].createdBy = this.app.user.userId;
            emails[0].createdDate = new Date();
            emails[0].createdSource = this.app.userIP;
            emails[0].updatedBy = this.app.user.userId;
            emails[0].email.createdBy = this.app.user.userId;
            emails[0].email.createdDate = new Date();
            emails[0].email.createdSource = this.app.userIP;
            emails[0].email.emailTypeId = emails[0].emailTypeDD.id;
            emails[0].email.emailAddress = emails[0].email.emailAddress;
            emails[0].email.updatedBy = this.app.user.userId;
            delete emails[0].emailTypeDD;
        } else {
            emails = null;
        }
        contactData.contactEmails = emails;

        if (this.storedContactDetails && this.storedContactDetails.contactPhones && this.storedContactDetails.contactPhones.length > 0) {
            for (const stored of this.storedContactDetails.contactPhones) {
                const getActualPhones = contactData.contactPhones.find(el => el['phone'].phoneTypeId == stored['phone'].phoneTypeId);
                const getActualPhonesIndex = contactData.contactPhones.findIndex(el => el['phone'].phoneTypeId == stored['phone'].phoneTypeId);
                getActualPhones['phone'].number = getActualPhones['phone'].number ? getActualPhones['phone'].number.trim() : "";
                if (getActualPhones && getActualPhones['phone'].number == '') {
                    getActualPhones['phone'].number = stored['phone'].number;
                    getActualPhones['phone'].statusId = 3;
                }
                contactData.contactPhones[getActualPhonesIndex] = getActualPhones;
            }
        }
        let phones = contactData.contactPhones;
        phones = phones.filter((data) => {
            return data.phoneTypeDD?.id !== 0 && data.phone?.number !== ''
        });
        if (phones && phones.length > 1) {
            for (let i = 0; i < phones.length; i++) {
                if (phones[i].contactId !== 0) {
                    phones[i].updatedBy = this.app.user.userId;
                    phones[i].updatedDate = new Date();
                    phones[i].updatedSource = this.app.userIP;
                    phones[i].phone.updatedBy = this.app.user.userId;
                    phones[i].phone.updatedDate = new Date();
                    phones[i].phone.updatedSource = this.app.userIP;
                }
                if (phones[i].createdBy === 0) {
                    phones[i].createdBy = this.app.user.userId;
                }
                if (phones[i].createdDate) {
                    phones[i].createdDate = new Date();
                }
                if (phones[i].createdSource === "") {
                    phones[i].createdSource = this.app.userIP;
                }
                if (phones[i].phone.createdBy === 0) {
                    phones[i].phone.createdBy = this.app.user.userId;
                }
                if (phones[i].phone.createdDate) {
                    phones[i].phone.createdDate = new Date();
                }
                if (phones[i].phone.createdSource === "") {
                    phones[i].phone.createdSource = this.app.userIP;
                }
                phones[i].phone.phoneTypeId = phones[i] && phones[i].phoneTypeDD && phones[i].phoneTypeDD.id ? phones[i].phoneTypeDD.id : this.phonetype[0].id;
                phones[i].phone.number = phones[i].phone.number;
                delete phones[i].phoneTypeDD;
            }
        } else if (phones && phones.length > 0 && phones[0].phone.number !== "") {
            phones[0].createdBy = this.app.user.userId;
            phones[0].createdDate = new Date();
            phones[0].createdSource = this.app.userIP;
            phones[0].updatedBy = this.app.user.userId;
            phones[0].phone.createdBy = this.app.user.userId;
            phones[0].phone.createdDate = new Date();
            phones[0].phone.createdSource = this.app.userIP;
            phones[0].phone.phoneTypeId = phones[0].phoneTypeDD.id;
            phones[0].phone.number = phones[0].phone.number;
            phones[0].phone.updatedBy = this.app.user.userId;
            delete phones[0].phoneTypeDD;
        } else {
            phones = null;
        }
        contactData.contactPhones = phones;

        if (phones?.length > 0) {
            phones.forEach(elem => {
              const phoneNumber = this.phoneNumberFormatService.removeMaskingFromNumber(elem.phone?.number);
              elem.phone.number = phoneNumber ? (elem.phone.code||'') + phoneNumber : '';
            });
            contactData.contactPhones = phones;
          }

        if (this.storedContactDetails && this.storedContactDetails.contactSocialProfiles && this.storedContactDetails.contactSocialProfiles.length > 0) {
            for (const stored of this.storedContactDetails.contactSocialProfiles) {
                const getActualSocial = contactData.contactSocialProfiles.find(el => el['socialProfile'].socialProfileTypeId == stored['socialProfile'].socialProfileTypeId);
                const getActualSocialIndex = contactData.contactSocialProfiles.findIndex(el => el['socialProfile'].socialProfileTypeId == stored['socialProfile'].socialProfileTypeId);
                if (getActualSocial && getActualSocial['socialProfile'].name == '') {
                    getActualSocial['socialProfile'].name = stored['socialProfile'].name;
                    getActualSocial['socialProfile'].statusId = 3;
                }
                contactData.contactSocialProfiles[getActualSocialIndex] = getActualSocial;
            }
        }
        let socials = contactData.contactSocialProfiles;
        socials = socials.filter((data) => {
            return data.socialProfileTypeDD?.id !== 0 && data.socialProfile?.name !== ''
        });
        if (socials && socials.length > 1) {
            for (let i = 0; i < socials.length; i++) {
                if (socials[i].contactId !== 0) {
                    socials[i].updatedBy = this.app.user.userId;
                    socials[i].updatedDate = new Date();
                    socials[i].updatedSource = this.app.userIP;
                    socials[i].socialProfile.updatedBy = this.app.user.userId;
                    socials[i].socialProfile.updatedDate = new Date();
                    socials[i].socialProfile.updatedSource = this.app.userIP;
                }
                if (socials[i].createdBy === 0) {
                    socials[i].createdBy = this.app.user.userId;
                }
                if (socials[i].createdDate) {
                    socials[i].createdDate = new Date();
                }
                if (socials[i].createdSource === "") {
                    socials[i].createdSource = this.app.userIP;
                }
                if (socials[i].socialProfile.createdBy === 0) {
                    socials[i].socialProfile.createdBy = this.app.user.userId;
                }
                if (socials[i].socialProfile.createdDate) {
                    socials[i].socialProfile.createdDate = new Date();
                }
                if (socials[i].socialProfile.createdSource === "") {
                    socials[i].socialProfile.createdSource = this.app.userIP;
                }
                socials[i].socialProfile.socialProfileTypeId = socials[i].socialProfileTypeDD.id;
                socials[i].socialProfile.name = socials[i].socialProfile.name;
                delete socials[i].socialProfileTypeDD;
            }
        } else if (socials && socials.length > 0 && socials[0].socialProfile.name !== "") {
            socials[0].createdBy = this.app.user.userId;
            socials[0].createdDate = new Date();
            socials[0].createdSource = this.app.userIP;
            socials[0].updatedBy = this.app.user.userId;
            socials[0].socialProfile.createdBy = this.app.user.userId;
            socials[0].socialProfile.createdDate = new Date();
            socials[0].socialProfile.createdSource = this.app.userIP;
            socials[0].socialProfile.socialProfileTypeId = socials[0].socialProfileTypeDD.id;
            socials[0].socialProfile.name = socials[0].socialProfile.name;
            socials[0].socialProfile.updatedBy = this.app.user.userId;
            delete socials[0].socialProfileTypeDD;
        } else {
            socials = null;
        }
        contactData.contactSocialProfiles = socials;

        const selectedLanguageIds = [];
        const selectedLangauges = [];

        this.selectedLanguage?.map(eachLanguage => {
            //remove duplicate language
            if (selectedLanguageIds.indexOf(eachLanguage.id) == -1) {
                selectedLanguageIds.push(eachLanguage.id);
                const existingLanguage = contactData.contactSpokenLanguages.find(language => language.languageId == eachLanguage.id)
                if (existingLanguage) {
                    selectedLangauges.push(existingLanguage);
                } else {
                    // create new language
                    const temp: any = {
                        id: 0,
                        createdBy: this.app.user.userId,
                        createdSource: this.app.user.userIP,
                        languageId: eachLanguage.id,
                        languages: eachLanguage.language,
                        statusId: Status.Active,
                        status: eachLanguage.status,
                        contactId: contactData.id,
                        createdDate: new Date(),
                        updatedDate: new Date(),
                        updatedBy: this.app.userId
                    }
                    selectedLangauges.push(temp);
                }
            }
        })

        contactData?.contactSpokenLanguages?.map(eachLanguage=>{
            const existingLanguage = this.selectedLanguage?.find(language => language.id == eachLanguage.languageId);
            if(!existingLanguage){
                selectedLangauges.push({
                    ...eachLanguage,
                    statusId: 3
                });
            }
        })

        contactData.contactSpokenLanguages = selectedLangauges?.length>0 ? selectedLangauges : null;

        if (!contactData.territories) {
            contactData.territories = null;
        } else {
            contactData.territories.map(territoryObj => {
                if (!territoryObj.statusId) {
                    territoryObj.statusId = Status.Active;
                }
                if (!territoryObj.organizationId) {
                    territoryObj.organizationId = this.app.user.organizationId;
                }
            })
        }
        contactData.contactAddresses = contactData.contactAddresses?.filter(el => el.address.statusId !== 3);
        for (const addressData of contactData.contactAddresses) {
            if (addressData.address.country) {
                addressData.address.country.statusId = 1;
            }
        }

        contactData['contactBusinessCards'] = contactData?.contactBusinessCards?.filter(attachment => attachment?.attachment)||[];

        this.appMainService.isShowSpinner('updateContact');
        this.contactService.updateContact(contactData).then(() => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact updated successfully...' });
            this.storedContactDetails = [];
            this.selectedLanguage = [];
            this.contactUpdated.emit(JSON.parse(JSON.stringify(contactData) || null));
            this.displayContactAddEdit = false;
            this.app.getAllObjects();
            this.addUpdateDone = true;
            this.appMainService.isHideSpinner('updateContact');
        }).catch((error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message||'Error occurred while saving data...' });
            this.appMainService.isHideSpinner('updateContact');
        });
    }

    // showViewContact({ id }) {
    //   let thisContact;

    //   this.sharedContactService.lionO36020APIContactIdGet(id).subscribe((contact: Contact) => {
    //     thisContact = JSON.parse(JSON.stringify(contact));
    //     this.selectedGender = thisContact.genderId && thisContact.genderId > 0 ? this.genders.filter(elem => elem.id === thisContact.genderId)[0] : this.genders[0];
    //     this.selectedLanguage = thisContact.contactSpokenLanguages.length > 0 ? this.languages.filter(elem => elem.id === thisContact.contactSpokenLanguages[0].languageId)[0] : this.languages[0];
    //     this.selectedRelation = thisContact.relationshipStatusId && thisContact.relationshipStatusId > 0 ? this.relations.filter(elem => elem.id === thisContact.relationshipStatusId)[0] : this.relations[0];
    //     this.selectedMarital = thisContact.maritalStatusId && thisContact.maritalStatusId > 0 ? this.maritals.filter(elem => elem.id === thisContact.maritalStatusId)[0] : this.maritals[0];
    //     this.selectedSource = thisContact.sourceId && thisContact.sourceId > 0 ? this.sources.filter(elem => elem.id === thisContact.sourceId)[0] : this.sources[0];
    //     this.selectedIncome = thisContact.annualIncomeId && thisContact.annualIncomeId > 0 ? this.incomes.filter(elem => elem.id === thisContact.annualIncomeId)[0] : this.incomes[0];
    //     this.selectedDegree = thisContact.degreeId && thisContact.degreeId > 0 ? this.degrees.filter(elem => elem.id === thisContact.degreeId)[0] : this.degrees[0];
    //     this.selectedStudyField = thisContact.fieldOfStudyId && thisContact.fieldOfStudyId > 0 ? this.studyFields.filter(elem => elem.id === thisContact.fieldOfStudyId)[0] : this.studyFields[0];
    //     this.selectedReportsTo = thisContact.reportsToId && thisContact.reportsToId > 0 ? this.reports.filter(elem => elem.id === thisContact.reportsToId)[0] : this.reports[0];
    //     this.selectedAssistant = thisContact.assistantId && thisContact.assistantId > 0 ? this.reports.filter(elem => elem.id === thisContact.assistantId)[0] : this.reports[0];
    //     this.selectedContactType = thisContact.contactTypeId && thisContact.contactTypeId > 0 ? this.contactTypes.filter(elem => elem.id === thisContact.contactTypeId)[0] : this.contactTypes[0];
    //     this.selectedContactAssociation = thisContact.contactAssociationTypeId && thisContact.contactAssociationTypeId > 0 ? this.contactAssociation.filter(elem => elem.id === thisContact.contactAssociationTypeId)[0] : this.contactAssociation.filter(el => el.id === this.contactAssociationId)[0];
    //     this.associationName = this.allAssociationNamesList && this.allAssociationNamesList.find(el => el.id == thisContact.associationId);

    //     if (thisContact.contactEmails.length > 0) {
    //       thisContact.contactEmails.forEach(email => {
    //         email["emailTypeDD"] = this.emailtypes.filter(elem => elem.name === email.email.emailType.name)[0];
    //       })
    //     } else {
    //       thisContact.contactEmails.push({
    //         "id": 0,
    //         "createdSource": this.app.userIP,
    //         "createdBy": this.app.user.userId,
    //         "createdDate": new Date(),
    //         "contactId": 0,
    //         "emailId": 0,
    //         "email": {
    //           "id": 0,
    //           "createdSource": this.app.userIP,
    //           "createdBy": this.app.user.userId,
    //           "createdDate": new Date(),
    //           "emailAddress": "",
    //           "description": "",
    //           "emailTypeId": 0,
    //           "statusId": Status.Active,
    //         },
    //         "emailTypeDD": {
    //           "name": "Work",
    //           "groupId": TypeGroupIds.EmailTypeId,
    //           "group": null,
    //           "parentTypeId": 0,
    //           "description": "",
    //           "statusId": Status.Active,
    //           "status": null,
    //           "organizationId": null,
    //           "colorCodeId": null,
    //           "id": 30,
    //           "createdSource": "10.1.1.1",
    //           "updatedSource": null,
    //           "createdBy": this.app.user.userId,
    //           "updatedBy": null,
    //           "createdDate": new Date("2020-12-23T12:06:21.43"),
    //           "updatedDate": null
    //         }
    //       });
    //     }

    //     if (thisContact.contactPhones.length > 0) {
    //       thisContact.contactPhones.forEach(phone => {
    //         phone["phoneTypeDD"] = this.phonetypes.filter(elem => elem.name === phone.phone.phoneType.name)[0];
    //       })
    //     } else {
    //       thisContact.contactPhones.push({
    //         "id": 0,
    //         "createdSource": this.app.userIP,
    //         "createdBy": this.app.user.userId,
    //         "createdDate": new Date(),
    //         "contactId": 0,
    //         "phoneId": 0,
    //         "phone": {
    //           "id": 0,
    //           "createdSource": this.app.userIP,
    //           "createdBy": this.app.user.userId,
    //           "createdDate": new Date(),
    //           "number": "",
    //           "extension": "",
    //           "description": "",
    //           "phoneTypeId": 0,
    //           "statusId": Status.Active,
    //         },
    //         "phoneTypeDD": {
    //           "name": "Mobile",
    //           "groupId": TypeGroupIds.PhoneTypeId,
    //           "group": null,
    //           "parentTypeId": 0,
    //           "description": "",
    //           "statusId": Status.Active,
    //           "status": null,
    //           "organizationId": null,
    //           "colorCodeId": null,
    //           "id": 10,
    //           "createdSource": "10.1.1.1",
    //           "updatedSource": null,
    //           "createdBy": this.app.user.userId,
    //           "updatedBy": null,
    //           "createdDate": new Date("2020-12-09T11:36:23.103"),
    //           "updatedDate": null
    //         }
    //       })
    //     }

    //     if (thisContact.contactSocialProfiles.length > 0) {
    //       thisContact.contactSocialProfiles.forEach(profile => {
    //         profile["socialProfileTypeDD"] = this.socialtypes.filter(elem => elem.name === profile.socialProfile.socialProfileType.name)[0];
    //       });
    //     } else {
    //       thisContact.contactSocialProfiles.push({
    //         "id": 0,
    //         "createdSource": this.app.userIP,
    //         "createdBy": this.app.user.userId,
    //         "createdDate": new Date(),
    //         "contactId": 0,
    //         "socialProfileId": 0,
    //         "socialProfile": {
    //           "id": 0,
    //           "createdSource": this.app.userIP,
    //           "createdBy": this.app.user.userId,
    //           "createdDate": new Date(),
    //           "name": "",
    //           "description": "",
    //           "socialProfileTypeId": 0,
    //           "statusId": Status.Active
    //         },
    //         "socialProfileTypeDD": {
    //           "name": "Website",
    //           "groupId": TypeGroupIds.SocialTypeAccountAPI,
    //           "group": null,
    //           "parentTypeId": 0,
    //           "description": "",
    //           "statusId": Status.Active,
    //           "status": null,
    //           "organizationId": null,
    //           "colorCodeId": null,
    //           "id": 34,
    //           "createdSource": "10.1.1.1",
    //           "updatedSource": null,
    //           "createdBy": this.app.user.userId,
    //           "updatedBy": null,
    //           "createdDate": new Date("2020-12-23T12:59:39.467"),
    //           "updatedDate": null
    //         }
    //       })
    //     }

    //     if (thisContact.contactEmails === null && thisContact.contactPhones === null) {
    //       this.isEmailOrPhoneThere = false;
    //     } else {
    //       this.isEmailOrPhoneThere = true;
    //     }

    //     if (thisContact.contactAddresses.length > 0) {
    //       thisContact.contactAddresses.forEach((address, i) => {
    //         address.index = i;
    //         this.addressCountry[i] = this.countries.filter(elem => elem.id === thisContact.contactAddresses[i].address.countryId)[0];
    //         if (this.addressCountry.length > 0) {
    //           this.contactService.getAllStates(this.addressCountry[i]['id']).then(states => {
    //             this.states[i] = states;
    //             this.addressState[i] = this.states[i].filter(elem => elem.id === thisContact.contactAddresses[i].address.state.id)[0];
    //             this.contactService.getAllCities(this.addressState[i]['id']).then(cities => {
    //               this.cities[i] = cities;
    //               this.addressCity[i] = this.cities[i].filter(elem => elem.id === thisContact.contactAddresses[i].address.city.id)[0];
    //             });
    //           });
    //         }
    //       });
    //     } else {
    //       thisContact.contactAddresses.push({
    //         "id": 0,
    //         "createdSource": this.app.userIP,
    //         "createdBy": this.app.user.userId,
    //         "createdDate": new Date(),
    //         "addressId": 0,
    //         "address": {
    //           "id": 0,
    //           "createdSource": this.app.userIP,
    //           "createdBy": this.app.user.userId,
    //           "createdDate": new Date(),
    //           "name": "",
    //           "description": "",
    //           "latitude": 0,
    //           "longitude": 0,
    //           "cityId": null,
    //           "stateId": null,
    //           "countryId": null,
    //           "zipCode": "",
    //           "addressTypeId": 0,
    //           "statusId": Status.Active
    //         }
    //       });
    //     }
    //     thisContact.associationName = this.object.businessName;
    //     this.contactTemp = JSON.parse(JSON.stringify(thisContact));
    //     this.displayContactView = true;
    //   })
    // }

    // getStatesFromCountry(country, id) {
    //   let countryID = country.id;
    //   this.contactService.getAllStates(countryID).then(states => {
    //     this.states[id] = states;
    //     //this.addressState[id] = states ? states[id] : null;
    //     this.addressState[id] = null;
    //   });
    // }

    // async getAsyncStatesFromCountry(country, id) {
    //   let countryID = country.id;
    //   await this.contactService.getAllStates(countryID).then(states => {
    //     this.states[id] = states;
    //     this.addressState[id] = states ? states[id] : null;
    //   });
    // }

    // getCitiesFromState(state, id) {
    //   this.contactService.getAllCities(state.id).then(cities => {
    //     this.cities[id] = cities;
    //     //this.addressCity[id] = cities ? cities[id] : null;
    //     this.addressCity[id] = null;
    //   });

    // }

    // async getAsyncCitiesFromState(state, id) {
    //   await this.contactService.getAllCities(state.id).then(cities => {
    //     this.cities[id] = cities;
    //     this.addressCity[id] = cities ? cities[id] : null;
    //   });
    // }

    checkClearBitEmail() {
        let email = this.contactTemp.contactEmails[0].email.emailAddress;
        this.showAddMore = true;
        if (email !== "") {
            this.contactService.checkClearBitData(email).then(res => {
                this.contactTemp.firstName = res.person.name.givenName ? res.person.name.givenName : "";
                this.contactTemp.lastName = res.person.name.familyName ? res.person.name.familyName : "";
                this.contactTemp.title = res.person.employment.title ? res.person.employment.title : "";
                this.contactTemp.contactAddresses[0].address.name = res.company ? res.company.location : "";
                this.contactTemp.contactPhones[0].phone.number = res.company ? res.company.site.phoneNumbers[0] : "";
                this.contactTemp.contactSocialProfiles[0].socialProfile.name = res.company.linkedin.handle ? res.company.linkedin.handle : "";
            }).catch(() => { });
        }
    }

    add(type) {
        if (type === "email") {
            this.contactTemp.contactEmails.push({
                "id": 0,
                "createdSource": this.app.userIP,
                "createdBy": this.app.user.userId,
                "createdDate": new Date(),
                "contactId": 0,
                "emailId": 0,
                "email": {
                    "id": 0,
                    "createdSource": this.app.userIP,
                    "createdBy": this.app.user.userId,
                    "createdDate": new Date(),
                    "emailAddress": "",
                    "description": "",
                    "emailTypeId": 0,
                    "statusId": Status.Active,
                },
                "emailTypeDD": {
                    "name": "Work",
                    "groupId": TypeGroupIds.EmailTypeId,
                    "group": null,
                    "parentTypeId": 0,
                    "description": "",
                    "statusId": Status.Active,
                    "status": null,
                    "organizationId": null,
                    "colorCodeId": null,
                    "id": 30,
                    "createdSource": "10.1.1.1",
                    "updatedSource": null,
                    "createdBy": this.app.user.userId,
                    "updatedBy": null,
                    "createdDate": new Date("2020-12-23T12:06:21.43"),
                    "updatedDate": null
                }
            })
        } else if (type === "phone") {
            this.contactTemp.contactPhones.push({
                "id": 0,
                "createdSource": this.app.userIP,
                "createdBy": this.app.user.userId,
                "createdDate": new Date(),
                "contactId": 0,
                "phoneId": 0,
                "phone": {
                    "id": 0,
                    "createdSource": this.app.userIP,
                    "createdBy": this.app.user.userId,
                    "createdDate": new Date(),
                    "number": "",
                    "extension": "",
                    "description": "",
                    "phoneTypeId": 0,
                    "statusId": Status.Active
                },
                "phoneTypeDD": {
                    "name": "Mobile",
                    "groupId": TypeGroupIds.PhoneTypeId,
                    "group": null,
                    "parentTypeId": 0,
                    "description": "",
                    "statusId": Status.Active,
                    "status": null,
                    "organizationId": null,
                    "colorCodeId": null,
                    "id": 10,
                    "createdSource": "10.1.1.1",
                    "updatedSource": null,
                    "createdBy": this.app.user.userId,
                    "updatedBy": null,
                    "createdDate": new Date("2020-12-09T11:36:23.103"),
                    "updatedDate": null
                }
            })
        } else if (type === "socialProfile") {
            this.contactTemp.contactSocialProfiles.push({
                "id": 0,
                "createdSource": this.app.userIP,
                "createdBy": this.app.user.userId,
                "createdDate": new Date(),
                "contactId": 0,
                "socialProfileId": 0,
                "socialProfile": {
                    "id": 0,
                    "createdSource": this.app.userIP,
                    "createdBy": this.app.user.userId,
                    "createdDate": new Date(),
                    "name": "",
                    "description": "",
                    "socialProfileTypeId": 0,
                    "statusId": Status.Active
                },
                "socialProfileTypeDD": {
                    "name": "Website",
                    "groupId": TypeGroupIds.SocialTypeAccountAPI,
                    "group": null,
                    "parentTypeId": 0,
                    "description": "",
                    "statusId": Status.Active,
                    "status": null,
                    "organizationId": null,
                    "colorCodeId": null,
                    "id": 34,
                    "createdSource": "10.1.1.1",
                    "updatedSource": null,
                    "createdBy": this.app.user.userId,
                    "updatedBy": null,
                    "createdDate": new Date("2020-12-23T12:59:39.467"),
                    "updatedDate": null
                }
            })
        }
    }

    // onFocusOutAddressLabel(element) {
    //   element.disabled = true;
    // }

    // onEditAddressLabel(element) {
    //   element.disabled = false;
    //   element.focus();
    // }

    // showAddAddress() {
    //   this.addressTemp = {
    //     "id": 0,
    //     "createdSource": this.app.userIP,
    //     "createdBy": this.app.user.userId,
    //     "createdDate": new Date(),
    //     "contactId": 0,
    //     "addressId": 0,
    //     "index": this.contactTemp.contactAddresses[this.contactTemp.contactAddresses.length - 1],
    //     "isSameAsMaillingAddress": false,
    //     "address": {
    //       "id": 0,
    //       "name": "Other Address",
    //       "createdSource": this.app.userIP,
    //       "createdBy": this.app.user.userId,
    //       "createdDate": new Date(),
    //       "streetAddress1": "",
    //       "streetAddress2": "",
    //       "description": "",
    //       "latitude": 0,
    //       "longitude": 0,
    //       "cityId": null,
    //       "stateId": null,
    //       "countryId": null,
    //       "zipCode": "",
    //       "addressTypeId": 0,
    //       "statusId": Status.Active
    //     }
    //   }
    //   this.disaplayAddAddressDialog = true;
    // }

    // onAddAddress(addressTemp) {
    //   addressTemp.address.countryId = this.addressCountry[addressTemp.index] ? this.addressCountry[addressTemp.index]['id'] : null;
    //   addressTemp.address.stateId = this.addressState[addressTemp.index] ? this.addressState[addressTemp.index]['id'] : null;
    //   addressTemp.address.cityId = this.addressCity[addressTemp.index] ? this.addressCity[addressTemp.index]['id'] : null;

    //   this.contactTemp.contactAddresses.push(addressTemp);
    //   this.disaplayAddAddressDialog = false;
    // }

    // clearTempAddressForm(addressTemp) {
    //   this.addressCountry[addressTemp.index] = null;
    //   this.addressState[addressTemp.index] = null;
    //   this.addressCity[addressTemp.index] = null;
    //   this.disaplayAddAddressDialog = false;

    // }

    // removeAddress() {
    //   let curAddress;
    //   curAddress = JSON.parse(JSON.stringify(this.contactTemp));
    //   curAddress.contactAddresses.splice(-1, curAddress.contactAddresses.length)

    //   this.contactTemp = JSON.parse(JSON.stringify(curAddress));
    // }

    saveData(event) {
        this.selectedLanguage = event.selectedLanguage;
        this.selectedRelation = event.selectedRelation;
        this.selectedIncome = event.selectedIncome;
        this.selectedDegree = event.selectedDegree;
        this.selectedGender = event.selectedGender;
        this.selectedStudyField = event.selectedStudyField;
        this.selectedSource = event.selectedSource;
        this.selectedMarital = event.selectedMarital;
        this.selectedContactRole = event.selectedContactRole;
        this.associationName = event.associationName;
        //this.activeContactEmails = event.activeContactEmails;
        this.createContact = event.createContact;
        this.selectedContactType = event.selectedContactType;
        this.selectedContactAssociation = event.selectedContactAssociation;
        this.selectedReportsTo = event.selectedReportsTo;
        this.addressCountry = event.addressCountry;
        this.addressState = event.addressState;
        this.addressCity = event.addressCity;
        this.states = event.states;
        this.selectedAssistant = event.selectedAssistant;
        this.selectedSalutation = event.selectedSalutation;
        if (event.formtype == 'save') { this.saveContact(); } else { this.updateEditContact() }
    }

    cancelTask(event) {
        this.displayActivityTaskAdd = event.cancelTask;
    }

    cancelNote(event) {
        this.displayNotesAdd = event.cancelTask;
    }

    cancelLog(event) {
        this.displayAddLog = event.cancelLog;
    }

    cancelEvent(event) {
        this.displayAddEvent = event.cancelEvent;
    }

    cancelEmail(event) {
        this.displaySendEmail = event.cancelEmail;
    }

    showRelationship(contactData): void{
        this.selectedAccount = contactData;
        const data = {
            contactId: contactData?.id,
            accountId: this.object?.id||contactData?.associationId
        }
        this.appMainService.isShowSpinner('getContactRelation');
        this.contactRelationService.getContactRelation(data?.accountId, data?.contactId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.relationship = response;
                    this.displayRelationship = true;
                    this.appMainService.isHideSpinner('getContactRelation');
                    this.changeAllAccess();
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getContactRelation');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.Message ? error?.error?.Message : 'Relationships are not loaded...'
                    });

                }
        });
        // this.relationship = [
        //     {childAccountId: 1, name: 'child 1', hasAccess: true},
        //     {childAccountId: 2, name: 'child 2', hasAccess: false},
        //     {childAccountId: 3, name: 'child 3', hasAccess: true}
        // ]
        // this.displayRelationship = true;
    }

    checkAllAccess(){
        if(this.relationship?.length>0){
            for(let s of this.relationship){
                s.hasAccess = this.hasAccessAll;
            }
        }
    }

    changeAllAccess(){
        for(let s of this.relationship){
            if(s.hasAccess == false){
                this.hasAccessAll = false;
                break;
            } else {
                this.hasAccessAll = true;
            }
        }
    }
    saveRelationship(): void {
        const childAccounts: number[] = this.relationship
            .filter(relation => relation.hasAccess)
            .map(relation => relation.childAccountId);
        const result = {
            accountId: this.object?.id||this.selectedAccount?.associationId,
            contactId: this.selectedAccount?.id,
            childAccountIds: childAccounts.length > 0 ? childAccounts : []
        }

        this.appMainService.isShowSpinner('saveRelationship');
        this.contactRelationService.saveContactRelation(result)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.displayRelationship = false;
                    this.contactUpdated.emit();
                    this.appMainService.isHideSpinner('saveRelationship');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('saveRelationship');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.Message ? error?.error?.Message : 'Relationships are not updated, please try again later...'
                    });

                }
        });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
